import React, { Component, Fragment } from 'react'
import Service from '../service/Service';
const service = new Service();
import Cookies from 'js-cookie';
import * as actions from './actions';

import { fetchInitialData5} from "../fetchData";
import FilterCategory from './FilterCategory';
import CollectionListPopupAmp from './CollectionListPopupAmp';
import { Bling as GPT } from "react-gpt";

const gptAry = {
    "20": {
        "desktop": {
            path: "/84382175/parenting.com/parenting.com_baby_names_list_DesktopParenting-UAE_baby_names_list_Desktop",
            slot: [[728, 90], [336, 280], [300, 250], [696, 200]],
            id: "div-gpt-ad-1592987750355-0"
        },
        "msite": {
            path: "/84382175/parenting.com/parenting.com_baby_names_list_msite",
            slot: [[300, 250], [320, 50], [336, 280], [320, 100]],
            id: "div-gpt-ad-1592990064959-0"
        }
    },
    "30": {
        "desktop": {
            path: "/84382175/parenting.com/parenting.com_baby_names_list_Desktop_Block2",
            slot: [[696, 200], [300, 250], [336, 280], [728, 90]],
            id: "div-gpt-ad-1592987760772-0"
        },
        "msite": {
            path: "/84382175/parenting.com/Parenting.com_baby_names_list_Msite_Block2",
            slot: [[336, 280], [320, 50], [320, 100], [300, 250]],
            id: "div-gpt-ad-1592990072274-0"
        }
    },
    "40": {
        "desktop": {
            path: "/84382175/parenting.com/parenting.com_baby_names_list_Desktop_Block3",
            slot: [[728, 90], [336, 280], [300, 250], [696, 200]],
            id: "div-gpt-ad-1592987767045-0"
        },
        "msite": {
            path: "/84382175/parenting.com/Parenting.com_baby_names_list_Msite_Block3",
            slot: [[320, 100], [320, 50], [336, 280], [300, 250]],
            id: "div-gpt-ad-1592990078261-0"
        }
    },
    "50": {
        "desktop": {
            path: "/84382175/parenting.com/parenting.com_baby_names_list_Desktop_Block4",
            slot: [[728, 90], [300, 250], [696, 200], [336, 280]],
            id: "div-gpt-ad-1592987773326-0"
        },
        "msite": {
            path: "/84382175/parenting.com/Parenting.com_baby_names_list_Msite_Block4",
            slot: [[320, 100], [320, 50], [336, 280], [300, 250]],
            id: "div-gpt-ad-1592990089740-0"
        }
    },
    "60": {
        "desktop": {
            path: "/84382175/parenting.com/parenting.com_baby_names_list_Desktop_Block5",
            slot: [[300, 250], [696, 200], [336, 280], [728, 90]],
            id: "div-gpt-ad-1592987779504-0"
        },
        "msite": {
            path: "/84382175/parenting.com/Parenting.com_baby_names_list_Msite_Block5",
            slot: [[336, 280], [300, 250], [320, 100], [320, 50]],
            id: "div-gpt-ad-1592990094876-0"
        }
    },
    "70": {
        "desktop": {
            path: "/84382175/parenting.com/parenting.com_baby_names_list_Desktop_Block6",
            slot: [[728, 90], [336, 280], [300, 250], [696, 200]],
            id: "div-gpt-ad-1592987785583-0"
        },
        "msite": {
            path: "/84382175/parenting.com/Parenting.com_baby_names_list_Msite_Block6",
            slot: [[300, 250], [336, 280], [320, 100], [320, 50]],
            id: "div-gpt-ad-1592990100033-0"
        }
    },
    "80": {
        "desktop": {
            path: "/84382175/parenting.com/parenting.com_baby_names_list_Desktop_Block7",
            slot: [[300, 250], [728, 90], [336, 280], [696, 200]],
            id: "div-gpt-ad-1592987801296-0"
        },
        "msite": {
            path: "/84382175/parenting.com/Parenting.com_baby_names_list_Msite_Block7",
            slot: [[300, 250], [320, 100], [320, 50], [336, 280]],
            id: "div-gpt-ad-1592990104716-0"
        }
    },
    "90": {
        "desktop": {
            path: "/84382175/parenting.com/parenting.com_baby_names_list_Desktop_Block8",
            slot: [[696, 200], [300, 250], [336, 280], [728, 90]],
            id: "div-gpt-ad-1592987806334-0"
        },
        "msite": {
            path: "/84382175/parenting.com/Parenting.com_baby_names_list_Msite_Block8",
            slot: [[320, 50], [320, 100], [300, 250], [336, 280]],
            id: "div-gpt-ad-1592990110230-0"
        }
    },
    "100": {
        "desktop": {
            path: "/84382175/parenting.com/parenting.com_baby_names_list_Desktop_Block9",
            slot: [[336, 280], [300, 250], [728, 90], [696, 200]],
            id: "div-gpt-ad-1592987812927-0"
        },
        "msite": {
            path: "/84382175/parenting.com/Parenting.com_baby_names_list_Msite_Block9",
            slot: [[300, 250], [320, 100], [320, 50], [336, 280]],
            id: "div-gpt-ad-1592990115029-0"
        }
    }
}

var recordID = "";
var babynametoadd = "";
var isReligionOrigin = false;

class BabynamesListingAmp extends Component {
    constructor(props) {
        super(props)
        let listingData = [];
        let totalResult = '';
        let noDataContent = [];
        let filterData = [];
        let collectionListData = [];
        let window_width = 1024;
        let articleData = [];
        let alsoData = [];
        let initialData = [];
        let headingData = "Baby Names";
        
        let metaDescription = [];
        let descTxt = '';
        // let paginationData = {};
        this.totalCount = 0;

        this.alphabetsAry = [];
        let _breadcrum_1 = "";
        let _breadcrum_2 = "";

        for (let i = 0; i < 26; i++) {
            this.alphabetsAry.push((i + 10).toString(36));
        }
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            if (window.__initialData__['initialData']['data4']) {
                if(window.__initialData__['initialData']['data4']['msg'] !== -1 && window.__initialData__['initialData']['data4']['SearchData'] !== "Records Not Found"){
                    listingData = window.__initialData__['initialData']['data4']['SearchData'];
                    this.totalCount = window.__initialData__['initialData']['data4']['totalresult'];
                } else{
                    noDataContent = window.__initialData__['initialData']['data4']['categoryList'];
                }
            }
            if (window.__initialData__['initialData']['data5']) {
                collectionListData = window.__initialData__['initialData']['data5']['FinalResponse'];
            }
            if (window.__initialData__['initialData']['data3']) {
                filterData = window.__initialData__['initialData']['data3']['filters'];
            }

            if (window.__initialData__['initialData']['data1']) {
                articleData = window.__initialData__['initialData']['data1']['article'];
            }
            
            if(window.__initialData__['initialData']['data2']){
                alsoData = window.__initialData__['initialData']['data2']['AlsoData'];
            }
            var _obj = actions.getBabyNamesData(window.location.pathname);

            if(props.staticContext.initialData['initialData']['data4']['totalresult']){
                totalResult = props.staticContext.initialData['initialData']['data4']['totalresult'];    
            }

            if(totalResult){
                descTxt = _obj.postDetails._descText.replace(/100+/g, totalResult).replace(/[+]/g, '');
            } else {
                descTxt = _obj.postDetails._descText.replace(/100+/g, '').replace(/[+]/g, '');
            }

            headingData = _obj.metaDetails.heading;
            _breadcrum_1 = _obj.postDetails._breadcrum_1;
            _breadcrum_2 = _obj.postDetails._breadcrum_2;
            
            delete window.__initialData__;
        } else {
            
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                if (props.staticContext.initialData['initialData']['data4']) {
                    if(props.staticContext.initialData['initialData']['data4']['msg'] !== -1 && props.staticContext.initialData['initialData']['data4']['SearchData'] !== "Records Not Found") {
                        listingData = props.staticContext.initialData['initialData']['data4']['SearchData'];
                        this.totalCount = props.staticContext.initialData['initialData']['data4']['totalresult'];
                    } else {
                        noDataContent = props.staticContext.initialData['initialData']['data4']['categoryList'];
                    }
                }
                
                if (props.staticContext.initialData['initialData']['data5'] && props.staticContext.initialData['initialData']['data5']['msg'] != '-1') {
                    collectionListData = props.staticContext.initialData['initialData']['data5']['FinalResponse'];
                }

                if (props.staticContext.initialData['initialData']['data3'] && props.staticContext.initialData['initialData']['data3']['filters']) {
                    filterData = props.staticContext.initialData['initialData']['data3']['filters'];
                }

                if (props.staticContext.initialData['initialData']['data1'] && props.staticContext.initialData['initialData']['data1']['article']) {
                    articleData = props.staticContext.initialData['initialData']['data1']['article'];
                }

                if (props.staticContext.initialData['initialData']['data2'] && props.staticContext.initialData['initialData']['data2']['AlsoData']) {
                    alsoData = props.staticContext.initialData['initialData']['data2']['AlsoData'];
                }
                var urlsrt = (props.location.pathname + props.location.search);
                
                var _obj = actions.getBabyNamesData((urlsrt));
            
                if(props.staticContext.initialData['initialData']['data4']['totalresult']){
                    totalResult = props.staticContext.initialData['initialData']['data4']['totalresult'];    
                }
                if(totalResult){
                    descTxt = _obj.postDetails._descText.replace(/100+/g, totalResult).replace(/[+]/g, '');
                } else {
                    descTxt = _obj.postDetails._descText.replace(/100+/g, '').replace(/[+]/g, '');
                }
                headingData = _obj.metaDetails.heading;
                _breadcrum_1 = _obj.postDetails._breadcrum_1;
                _breadcrum_2 = _obj.postDetails._breadcrum_2;
                
            }
        }
        this.totalpages = Math.ceil(totalResult/100);
        if((props.location.pathname.split("/")[2] == "origin" || props.location.pathname.split("/")[2] == "religion") && props.location.pathname.split("/")[3] == "amp"){
            isReligionOrigin = true;
        } else {
            isReligionOrigin = false;
        }
        
        this.state = {
            listingData: listingData,
            totalResult: totalResult,
            noDataContent: noDataContent,
            filterData: filterData,
            collectionListData: collectionListData,
            window_width : window_width,
            articleData : articleData,
            alsoData : alsoData,
            isReligionOrigin : isReligionOrigin,
            headingData : headingData, 
            metaDescription: metaDescription,
            descTxt : descTxt,
            breadcrum_1 : _breadcrum_1,
            breadcrum_2 : _breadcrum_2,
            filterapplied : false
        };
        
        this.disPageNo = 1;
        if (this.props.match.params.page && this.props.match.params.page > 0) {
            this.disPageNo = parseInt(this.props.match.params.page);
        }

        this.maxScroll = 0;
        this.timeout = 0;
    }

    static initialAction(reqUrl, ftk, authData, uId, childData, cookieData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var pageno = 1;
        
        //for listing page
      
        var urlsrt = reqUrl;
        var size = 100;
        var _value_2 = urlsrt.split("/")[2];
        _value_2 = _value_2 ? _value_2 : "";
        (_value_2 && _value_2.includes('?')) ? (_value_2 = _value_2.split('?')[0]) : (_value_2 = _value_2);
    
        var _value_3 = urlsrt.split("/")[3];
        _value_3 = _value_3 ? _value_3 : "";
        (_value_3 &&_value_3.includes('?')) ? (_value_3 = _value_3.split('?')[0]) : (_value_3 = _value_3);

        var _value_4 = urlsrt.split("/")[4];
        _value_4 = _value_4 ? _value_4 : "";
        (_value_4 && _value_4.includes('?')) ? (_value_4 = _value_4.split('?')[0]) : (_value_4 = _value_4);

        var _value_5 = urlsrt.split("/")[5];
        _value_5 = _value_5 ? _value_5 : "";
        (_value_5 && _value_5.includes('?')) ? (_value_5 = _value_5.split('?')[0]) : (_value_5 = _value_5);

        var _value_6 = urlsrt.split("/")[6];
        _value_6 = _value_6 ? _value_6 : "";
        (_value_6 && _value_6.includes('?')) ? (_value_6 = _value_6.split('?')[0]) : (_value_6 = _value_6);

        var _value_7 = urlsrt.split("/")[7];
        _value_7 = _value_7 ? _value_7 : "";
        (_value_7 && _value_7.includes('?')) ? (_value_7 = _value_7.split('?')[0]) : (_value_7 = _value_7);

        var _value_8 = urlsrt.split("/")[8];
        _value_8 = _value_8 ? _value_8 : "";
        (_value_8 && _value_8.includes('?')) ? (_value_8 = _value_8.split('?')[0]) : (_value_8 = _value_8);

        
            if(urlsrt.split("/")[2] !== "search"){
                var _selectedvalgender =  "all";
                var _selectedvalnumerology =  "all";
                var _selectedvalorigin =  "all";
                var _selectedvalreligion =  "all";
                var _selectedvalrashi =  "all";
                var _selectedvalnakshatra =  "all";
                var _selectedvalgod =  "all";
                var _selectedvalstarting =  "all";
                
                if(_value_4 == "starting-with" || _value_5 == "starting-with"){
                    var _selectedvalgender =  "all";
                    var _selectedvalnumerology =  "all";
                    var _selectedvalorigin =  "all";
                    var _selectedvalreligion =  "all";
                    var _selectedvalrashi =  "all";
                    var _selectedvalnakshatra =  "all";
                    var _selectedvalgod =  "all";

                    if(_value_4 == "starting-with"){
                       if(_value_6 == "page"){
                            pageno = _value_7;
                        } else {
                            pageno = 1;
                        }
                        var _selectedvalstarting = [];
                        _selectedvalstarting.push(_value_5);

                        if(_value_2 == "religion"){
                        var _selectedvalreligion = [];
                            _selectedvalreligion.push(_value_3);
                        }
                        if(_value_2 == "origin"){
                            var _selectedvalorigin = [];
                            _selectedvalorigin.push(_value_3);
                        }
                        if(_value_2 == "numerology"){
                            var _selectedvalnumerology = [];
                            _selectedvalnumerology.push(_value_3);                    
                        }
                        if(_value_2 == "rashi"){
                            var _selectedvalrashi = [];
                            _selectedvalrashi.push(_value_3);
                        }
                        if(_value_2 == "nakshatra"){
                            var _selectedvalnakshatra = [];
                            _selectedvalnakshatra.push(_value_3);
                        }
                        if(_value_2 == "god-goddesses"){
                            var _selectedvalgod = [];
                            _selectedvalgod.push(_value_3);
                        }

                    } else {
                        // if(urlsrt.split("/")[7] != "?ref2=bnalsoreadsection"){
                            if(_value_7 == "page"){
                                pageno = _value_8;
                            } else {
                                pageno = 1;
                            }
    
                            var _selectedvalstarting = [];
                            _selectedvalstarting.push(_value_6);
                            
                            var _selectedvalgender = [];
                            _selectedvalgender.push(_value_2);
                            
                            if(_value_3 == "religion"){
                                var _selectedvalreligion = [];
                                _selectedvalreligion.push(_value_4);
                            }
                            if(_value_3 == "origin"){
                                var _selectedvalorigin = [];
                                _selectedvalorigin.push(_value_4);
                            }
                            if(_value_3 == "numerology"){
                                var _selectedvalnumerology = [];
                                _selectedvalnumerology.push(_value_4);
                            }
                            if(_value_3 == "rashi"){
                                var _selectedvalrashi = [];
                                _selectedvalrashi.push(_value_4);
                            }
                            if(_value_3 == "nakshatra"){
                                var _selectedvalnakshatra = [];
                                _selectedvalnakshatra.push(_value_4);
                            }
                            if(_value_3 == "god-goddesses"){
                                var _selectedvalgod = [];
                                _selectedvalgod.push(_value_4);
                            }
                        // }
                    }
                } else {
                    var _selectedvalgender =  "all";
                    var _selectedvalnumerology =  "all";
                    var _selectedvalorigin =  "all";
                    var _selectedvalreligion =  "all";
                    var _selectedvalrashi =  "all";
                    var _selectedvalnakshatra =  "all";
                    var _selectedvalgod =  "all";
                    var _selectedvalstarting =  "all";
                    
                    if((_value_2 == "boy" || _value_2 == "girl" || _value_2 =="unisex")){
                        if(_value_3 == "page"){
                            pageno = _value_4;
                        } else if(_value_4 == "page"){
                            pageno = _value_5;
                        } else if(_value_5 == "page"){
                            pageno = _value_6;
                        } else {
                            pageno = 1;
                        }

                        var _selectedvalgender = [];

                        _selectedvalgender.push(_value_2);

                        if(_value_3 == "religion" && _value_4 != "" && (_value_4 != "page" && _value_4 != "amp")){
                            var _selectedvalreligion = [];
                            _selectedvalreligion.push(_value_4);
                        } 
                        if(_value_3 == "origin"  && _value_4 != ""&& (_value_4 != "page" && _value_4 != "amp")){
                            var _selectedvalorigin = [];
                            _selectedvalorigin.push(_value_4);
                        }
                        if(_value_3 == "numerology" && _value_4 != "" && (_value_4 != "page" && _value_4 != "amp")){
                            var _selectedvalnumerology = [];
                            _selectedvalnumerology.push(_value_4);
                        }
                        if(_value_3 == "rashi" && _value_4 != "" && (_value_4 != "page" && _value_4 != "amp")){
                            var _selectedvalrashi = [];
                            _selectedvalrashi.push(_value_4);
                        }
                        if(_value_3 == "nakshatra" && _value_4 != "" && (_value_4 != "page" && _value_4 != "amp")){
                            var _selectedvalnakshatra = [];
                            _selectedvalnakshatra.push(_value_4);
                        }
                        if(_value_3 == "god-goddesses" && _value_4 != "" && (_value_4 != "page" && _value_4 != "amp")){
                            var _selectedvalgod = [];
                            _selectedvalgod.push(_value_4);
                        }
                        if(_value_3 == "starting-with" && _value_4 != "" && (_value_4 != "page" && _value_4 != "amp")){
                            var _selectedvalstarting = [];
                            _selectedvalstarting.push(_value_4);
                        }
                    } else if(_value_2 == "religion" || _value_2 == "origin" || _value_2 == "numerology" || _value_2 == "rashi" || _value_2 == "nakshatra" || _value_2 == "god-goddesses" || _value_2 == "starting-with"){
                        if(_value_3 == "page"){
                            pageno = _value_4;
                        } else if(_value_4 == "page"){
                            pageno = _value_5;
                        } else if(_value_5 == "page"){
                            pageno = _value_6;
                        } else {
                            pageno = 1;
                        }
                       
                        if(_value_2 == "religion" && _value_3 != "" && (_value_3 != "page" && _value_3 != "amp")){
                            var _selectedvalreligion = [];
                            _selectedvalreligion.push(_value_3);
                        }
                        if(_value_2 == "origin" && _value_3 != "" && (_value_3 != "page" && _value_3 != "amp")){
                            var _selectedvalorigin = [];
                            _selectedvalorigin.push(_value_3);
                        }
                        if(_value_2 == "numerology" && _value_3 != "" && (_value_3 != "page" && _value_3 != "amp")){
                            var _selectedvalnumerology = [];
                            _selectedvalnumerology.push(_value_3);
                        }
                        if(_value_2 == "rashi" && _value_3 != "" && (_value_3 != "page" && _value_3 != "amp")){
                            var _selectedvalrashi = [];
                            _selectedvalrashi.push(_value_3);
                        }
                        if(_value_2 == "nakshatra" && _value_3 != "" && (_value_3 != "page" && _value_3 != "amp")){
                            var _selectedvalnakshatra = [];
                            _selectedvalnakshatra.push(_value_3);
                        }
                        if(_value_2 == "god-goddesses" && _value_3 != "" && (_value_3 != "page" && _value_3 != "amp")){
                            var _selectedvalgod = [];
                            _selectedvalgod.push(_value_3);
                        }
                        if(_value_2 == "starting-with" && _value_3 != "" && (_value_3 != "page" && _value_3 != "amp")){
                            var _selectedvalstarting = [];
                            _selectedvalstarting.push(_value_3);
                        }
                    }
                }
                if(_selectedvalorigin !=  "all"){
                    if(_selectedvalorigin.includes("-")){
                        _selectedvalorigin = actions.capitalize(_selectedvalorigin.split("-")[0]) + " " + actions.capitalize(_selectedvalorigin.split("-")[1]);
                    } else {
                        _selectedvalorigin = _selectedvalorigin;
                    }
                }
                if(_selectedvalgod !=  "all"){
                    if(_selectedvalgod.includes("-")){
                        _selectedvalgod = actions.capitalize(_selectedvalgod.split("-")[0]) + " " + actions.capitalize(_selectedvalgod.split("-")[1]);
                        
                    } else {
                        _selectedvalgod = _selectedvalgod;
                    }
                }
            } else {
                if(_value_4 == "page"){
                    pageno = _value_5;
                }else{
                    pageno = 1;
                }
		
		/*if (urlsrt.split("/amp/?").length > 1 && urlsrt.split("/amp/?")[1] != "") {
                const searchCats = urlsrt.split("/amp/?")[1];
                const catarray = searchCats.split("&");
                var genCat = catarray[0].split("=")[1];
                var religionCat = catarray[1].split("=")[1];
                var numerologyCat = catarray[2].split("=")[1];
                var rashiCat = catarray[3].split("=")[1];
                var nakshtraCat = catarray[4].split("=")[1];
                var startingCat = catarray[5].split("=")[1];
                var godCat = catarray[6].split("=")[1];
                var originCat = catarray[7].split("=")[1];
               }*/
                if(urlsrt.split("/amp/?").length > 1 && urlsrt.split("/amp/?")[1]!=""){
                    const searchCats = urlsrt.split("/amp/?")[1];
                    const catarray = searchCats.split("&");
                    var genCat = catarray[0].split("=")[1];
                    var religionCat = catarray[1].split("=")[1];
                    var nakshtraCat = catarray[2].split("=")[1];
                    var startingCat = catarray[3].split("=")[1];
                    var godCat = catarray[4].split("=")[1];
                    var numerologyCat = catarray[5].split("=")[1];
                    var rashiCat = catarray[6].split("=")[1];
                    var originCat = catarray[7].split("=")[1];
                } 
                if(genCat){
                    _selectedvalgender = genCat.split(",");
                } else {
                    _selectedvalgender = "all";
                }
                if(religionCat){
                    _selectedvalreligion = religionCat.split(",");
                } else {
                    _selectedvalreligion = "all";
                }
                if(numerologyCat){
                    _selectedvalnumerology = numerologyCat.split(",");
                }else {
                    _selectedvalnumerology = "all";
                }
                if(rashiCat){
                    _selectedvalrashi = rashiCat.split(",");
                }else {
                    _selectedvalrashi = "all";
                }
                if(nakshtraCat){
                _selectedvalnakshatra = nakshtraCat.split(",");
                } else {
                    _selectedvalnakshatra = "all";
                }
                if(startingCat){
                _selectedvalstarting = startingCat.split(",");
                } else {
                    _selectedvalstarting = "all";
                }
                if(godCat){
                _selectedvalgod = godCat.split(",");
                } else {
                    _selectedvalgod = "all";
                }
                if(originCat){
                _selectedvalorigin = originCat.split(",");
                } else {
                    _selectedvalorigin = "all";
                }
            }

            var _obj = actions.getBabyNamesData(urlsrt);
            var obj4 = {
                url : global.api_url + "getbabysearchbyfilters",
                body: JSON.stringify({
                    "gender": _selectedvalgender,
                    "religion": _selectedvalreligion,
                    "category": "",
                    "keyword" : "",
                    "startwith" : _selectedvalstarting,
                    "origin" : _selectedvalorigin,
                    "numerology" : _selectedvalnumerology,
                    "rashi" : _selectedvalrashi,
                    "nakshatra" : _selectedvalnakshatra,
                    "god" : _selectedvalgod,
                    "pageNo": pageno,
                    "pageSize" : size,
                    "sortkey" : _obj.postDetails.sortkey
                })
            }
       
        let obj1 = {
            url: global.api_url + "getarticlesdata",
            body:JSON.stringify({
                "pagesize": size,
                "pageno": 1
            })
        };
        let obj2 = {
            url: global.api_url + "getalsoreaddata",
            body: JSON.stringify({
                
            })
        };

        let obj3 = {
            url: global.api_url + "getfilterlist",
            body: JSON.stringify({
                
            })
        }
        let obj5 = {
            url: global.api_url + "getmyfavouritelist",
            body:JSON.stringify({
                "pagesize": size,
                "pageno": 1
            })
        };
        return fetchInitialData5(obj1, obj2, obj3, obj4, obj5,JSON.stringify(header));
    }

    // componentDidMount() {
    //     service.showLoader();
    //     document.addEventListener("click", actions.domClick);
    //     this.pageData = this.pageData.bind(this);
    //     document.querySelector(".listing_container").addEventListener("scroll", this.pageData, false);

    //     var _urlsrt = window.location.href;
    //     var urlsrt = window.location.pathname;
    //     var _url = window.location.pathname.split("/");

    //     var _value_2 = urlsrt.split("/")[2];
    //     _value_2 = _value_2 ? _value_2 : "";
    //     (_value_2 && _value_2.includes('?')) ? (_value_2 = _value_2.split('?')[0]) : (_value_2 = _value_2);
    
    //     var _value_3 = urlsrt.split("/")[3];
    //     _value_3 = _value_3 ? _value_3 : "";
    //     (_value_3 &&_value_3.includes('?')) ? (_value_3 = _value_3.split('?')[0]) : (_value_3 = _value_3);

    //     var _value_4 = urlsrt.split("/")[4];
    //     _value_4 = _value_4 ? _value_4 : "";
    //     (_value_4 && _value_4.includes('?')) ? (_value_4 = _value_4.split('?')[0]) : (_value_4 = _value_4);

    //     var _value_5 = urlsrt.split("/")[5];
    //     _value_5 = _value_5 ? _value_5 : "";
    //     (_value_5 && _value_5.includes('?')) ? (_value_5 = _value_5.split('?')[0]) : (_value_5 = _value_5);


    //     if(urlsrt !== "/baby-names/search/"){
    //         var _selectedvalgender =  "all";
    //         var _selectedvalnumerology =  "all";
    //         var _selectedvalorigin =  "all";
    //         var _selectedvalreligion =  "all";
    //         var _selectedvalrashi =  "all";
    //         var _selectedvalnakshatra =  "all";
    //         var _selectedvalgod =  "all";
    //         var _selectedvalstarting =  "all";

    //         if((_url[2] == "religion" || _url[2] == "origin") && ( _url[3] == "")){
    //             this.setState({ isReligionOrigin : true});
    //         }

    //         if((_value_2 == "religion" || _value_2 == "origin") && _value_3 == "" ){
    //             localStorage.setItem('selectedvalgender', '');
    //             localStorage.setItem('selectedvalgod', '');
    //             localStorage.setItem('selectedvalnakshatra', '');
    //             localStorage.setItem('selectedvalnumerology', '');
    //             localStorage.setItem('selectedvalorigin', '');
    //             localStorage.setItem('selectedvalrashi', '');
    //             localStorage.setItem('selectedvalreligion', '');
    //             localStorage.setItem('selectedvalstarting', '');
        
    //             Cookies.set('selectedvalgender', []);
    //             Cookies.set('selectedvalgod', []);
    //             Cookies.set('selectedvalnakshatra', []);
    //             Cookies.set('selectedvalnumerology', []);
    //             Cookies.set('selectedvalorigin', []);
    //             Cookies.set('selectedvalrashi', []);
    //             Cookies.set('selectedvalreligion', []);
    //             Cookies.set('selectedvalstarting', []);
    //         }

    //         if(_value_2 == "boy" || _value_2 == "girl" || _value_2=="unisex"){
    //             var _selectedvalgender = [];
    //             _selectedvalgender.push(_value_2);
    //             Cookies.set('selectedvalgender', _selectedvalgender);

    //             if(_value_3 == "starting-with"){
    //                 var _selectedvalstarting_ = [];
    //                 _selectedvalstarting_.push(_value_4);
    //                 Cookies.set('selectedvalstarting', _selectedvalstarting_);
    //             }
    //             if(_value_3 == "religion"){
    //                 var _selectedvalreligion = [];
    //                 _selectedvalreligion.push(_value_4);
    //                 Cookies.set('selectedvalreligion', _selectedvalreligion);
    //             }
    //             if(_value_3 == "origin"){
    //                 var _selectedvalorigin = [];
    //                 _selectedvalorigin.push(_value_4);
    //                 Cookies.set('selectedvalorigin', _selectedvalorigin);
    //             }
    //             if(_value_3 == "numerology"){
    //                 var _selectedvalnumerology = [];
    //                 _selectedvalnumerology.push(_value_4);
    //                 Cookies.set('selectedvalnumerology', _selectedvalnumerology);
    //             }
    //             if(_value_3 == "rashi"){
    //                 var _selectedvalrashi = [];
    //                 _selectedvalrashi.push(_value_4);
    //                 Cookies.set('selectedvalrashi', _selectedvalrashi);
    //             }
    //             if(_value_3 == "nakshatra"){
    //                 var _selectedvalnakshatra = [];
    //                 _selectedvalnakshatra.push(_value_4);
    //                 Cookies.set('selectedvalnakshatra', _selectedvalnakshatra);
    //             }
    //             if(_value_3 == "god-goddesses"){
    //                 var _selectedvalgod = [];
    //                 _selectedvalgod.push(_value_4);
    //                 Cookies.set('selectedvalgod', _selectedvalgod);
    //             }
    //         } else {
    //             if(_value_2 == "starting-with"){
    //                 var _selectedvalstarting_ = [];
    //                 _selectedvalstarting_.push(_value_3);
    //                 Cookies.set('selectedvalstarting', _selectedvalstarting_);
    //             }
    //             if(_value_2 == "religion"){
    //                 var _selectedvalreligion = [];
    //                 _selectedvalreligion.push(_value_3);
    //                 Cookies.set('selectedvalreligion', _selectedvalreligion);
    //             }
    //             if(_value_2 == "origin"){
    //                 var _selectedvalorigin = [];
    //                 _selectedvalorigin.push(_value_3);
    //                 Cookies.set('selectedvalorigin', _selectedvalorigin);
    //             }
    //             if(_value_2 == "numerology"){
    //                 var _selectedvalnumerology = [];
    //                 _selectedvalnumerology.push(_value_3);
    //                 Cookies.set('selectedvalnumerology', _selectedvalnumerology);
    //             }
    //             if(_value_2 == "rashi"){
    //                 var _selectedvalrashi = [];
    //                 _selectedvalrashi.push(_value_3);
    //                 Cookies.set('selectedvalrashi', _selectedvalrashi);
    //             }
    //             if(_value_2 == "nakshatra"){
    //                 var _selectedvalnakshatra = [];
    //                 _selectedvalnakshatra.push(_value_3);
    //                 Cookies.set('selectedvalnakshatra', _selectedvalnakshatra);
    //             }
    //             if(_value_2 == "god-goddesses"){
    //                 var _selectedvalgod = [];
    //                 _selectedvalgod.push(_value_3);
    //                 Cookies.set('selectedvalgod', _selectedvalgod);
    //             }
    //         }

    //         if(JSON.parse(Cookies.get('selectedvalgender')).length > 0)
    //         {localStorage.setItem('selectedvalgender', JSON.parse(Cookies.get('selectedvalgender'))[0]);}
    //         else {localStorage.setItem('selectedvalgender', '');}

    //         if(JSON.parse(Cookies.get('selectedvalgod')).length  > 0)
    //         {localStorage.setItem('selectedvalgod', JSON.parse(Cookies.get('selectedvalgod'))[0]);} 
    //         else {localStorage.setItem('selectedvalgod', '');}

    //         if(JSON.parse(Cookies.get('selectedvalnakshatra')).length  > 0)
    //         {localStorage.setItem('selectedvalnakshatra', JSON.parse(Cookies.get('selectedvalnakshatra'))[0]);}
    //         else {localStorage.setItem('selectedvalnakshatra', '');}

    //         if(JSON.parse(Cookies.get('selectedvalnumerology')).length  > 0)
    //         {localStorage.setItem('selectedvalnumerology', JSON.parse(Cookies.get('selectedvalnumerology'))[0]);}
    //         else {localStorage.setItem('selectedvalnumerology', '');}

    //         if(JSON.parse(Cookies.get('selectedvalorigin')).length  > 0)
    //         {localStorage.setItem('selectedvalorigin', JSON.parse(Cookies.get('selectedvalorigin'))[0]);}
    //         else {localStorage.setItem('selectedvalorigin', '');}

    //         if(JSON.parse(Cookies.get('selectedvalrashi')).length  > 0)
    //         {localStorage.setItem('selectedvalrashi', JSON.parse(Cookies.get('selectedvalrashi'))[0]);}
    //         else {localStorage.setItem('selectedvalrashi', '');}

    //         if(JSON.parse(Cookies.get('selectedvalreligion')).length  > 0)
    //         {localStorage.setItem('selectedvalreligion', JSON.parse(Cookies.get('selectedvalreligion'))[0]);}
    //         else {localStorage.setItem('selectedvalreligion', '');}

    //         if(JSON.parse(Cookies.get('selectedvalstarting')).length  > 0)
    //         {localStorage.setItem('selectedvalstarting', JSON.parse(Cookies.get('selectedvalstarting'))[0]);}
    //         else {localStorage.setItem('selectedvalstarting', '');}
    //     }

    //     if (navigator.onLine) {
    //         let size = 100;
    //         if (this.disPageNo > 1) {
    //             size = 100 * this.disPageNo;
    //         }
            
    //         if(this.state.listingData && this.state.listingData.length == 0 && this.state.noDataContent && this.state.noDataContent.length == 0){


    //             var _urlsrt = window.location.href;
                
    //             var urlsrt = window.location.pathname;
    //             if(_urlsrt && _urlsrt.includes("?sort")){
    //                 var _sturl = window.location.pathname + "?sort=" + _urlsrt.split("?sort=")[1];
    //             } else {
    //                 var _sturl = window.location.pathname;
    //             }

    //             if(_value_2 !== "search"){
                    
    //                 if(localStorage.getItem('selectedvalgender')){
    //                     var temp = [];
    //                     temp.push(localStorage.getItem('selectedvalgender'));
    //                     _selectedvalgender = temp;
    //                 } else {
    //                     _selectedvalgender =  "all";
    //                 }

    //                 if(localStorage.getItem('selectedvalnumerology')){
    //                     var temp = [];
    //                     temp.push(localStorage.getItem('selectedvalnumerology'));
    //                     _selectedvalnumerology = temp;
    //                 } else {
    //                     _selectedvalnumerology =  "all"
    //                 }

    //                 if(localStorage.getItem('selectedvalreligion')){
    //                     var temp = [];
    //                     temp.push(localStorage.getItem('selectedvalreligion'));
    //                     _selectedvalreligion = temp;
    //                 } else {
    //                     _selectedvalreligion =  "all"
    //                 }
    //                 if(localStorage.getItem('selectedvalorigin')){
    //                     var temp = [];
    //                     temp.push(localStorage.getItem('selectedvalorigin'));
    //                     _selectedvalorigin = temp;
    //                 } else {
    //                     _selectedvalorigin =  "all"
    //                 }
    //                 if(localStorage.getItem('selectedvalrashi')){
    //                     var temp = [];
    //                     temp.push(localStorage.getItem('selectedvalrashi'));
    //                     _selectedvalrashi = temp;
    //                 } else {
    //                     _selectedvalrashi =  "all"
    //                 }


    //                 if(localStorage.getItem('selectedvalnakshatra')){
    //                     var temp = [];
    //                     temp.push(localStorage.getItem('selectedvalnakshatra'));
    //                     _selectedvalnakshatra = temp;
    //                 } else {
    //                     _selectedvalnakshatra =  "all"
    //                 }

    //                 if(localStorage.getItem('selectedvalgod')){
    //                     var temp = [];
    //                     temp.push(localStorage.getItem('selectedvalgod'));
    //                     _selectedvalgod = temp;
    //                 } else {
    //                     _selectedvalgod =  "all"
    //                 }
    //                 if(localStorage.getItem('selectedvalstarting')){
    //                     var temp = [];
    //                     temp.push(localStorage.getItem('selectedvalstarting'));
    //                     _selectedvalstarting = temp;
    //                 } else {
    //                     _selectedvalstarting =  "all"
    //                 }
    //             } else if(_value_2 == "search"){
    //                 if(localStorage.getItem('selectedvalgender')){
    //                     _selectedvalgender = localStorage.getItem('selectedvalgender').split(",");

    //                 } else {
    //                     _selectedvalgender = "all";
    //                 }
    //                 if(localStorage.getItem('selectedvalreligion')){
    //                     _selectedvalreligion = localStorage.getItem('selectedvalreligion').split(",");
    //                 } else {
    //                     _selectedvalreligion = "all";
    //                 }
    //                 if(localStorage.getItem('selectedvalnumerology')){
    //                     _selectedvalnumerology = localStorage.getItem('selectedvalnumerology').split(",");
    //                 }else {
    //                     _selectedvalnumerology = "all";
    //                 }
    //                 if(localStorage.getItem('selectedvalrashi')){
    //                     _selectedvalrashi = localStorage.getItem('selectedvalrashi').split(",");
    //                 }else {
    //                     _selectedvalrashi = "all";
    //                 }

    //                 if(localStorage.getItem('selectedvalnakshatra')){
    //                     _selectedvalnakshatra = localStorage.getItem('selectedvalnakshatra').split(",");
    //                 } else {
    //                     _selectedvalnakshatra = "all";
    //                 }
    //                 if(localStorage.getItem('selectedvalstarting')){
    //                 _selectedvalstarting = localStorage.getItem('selectedvalstarting').split(",");
    //                 } else {
    //                     _selectedvalstarting = "all";
    //                 }
    //                 if(localStorage.getItem('selectedvalgod')){
    //                 _selectedvalgod = localStorage.getItem('selectedvalgod').split(",");
    //                 } else {
    //                     _selectedvalgod = "all";
    //                 }
    //                 if(localStorage.getItem('selectedvalorigin')){
    //                 _selectedvalorigin = localStorage.getItem('selectedvalorigin').split(",");
    //                 } else {
    //                     _selectedvalorigin = "all";
    //                 }
    //             }

    //             var _obj1 = actions.getBabyNamesData(_sturl, _selectedvalgender, _selectedvalreligion, _selectedvalnumerology, _selectedvalrashi, _selectedvalnakshatra, _selectedvalstarting, _selectedvalgod, _selectedvalorigin, localStorage.getItem('searchedname'));

    //             var gender = _selectedvalgender;
    //             var religion = _selectedvalreligion;
    //             var category = "";
    //             var keyword = "";
    //             var startwith = _selectedvalstarting;
    //             var origin = _selectedvalorigin;
    //             var numerology = _selectedvalnumerology;
    //             var rashi = _selectedvalrashi;
    //             var nakshatra = _selectedvalnakshatra;
    //             var god = _selectedvalgod;
    //             var pageNo = _obj1.postDetails.pageno;
    //             var pageSize = 100;
    //             var sortkey =_obj1.postDetails.sortkey;

    //             this.getListing(_selectedvalgender, _selectedvalreligion, category, keyword, _selectedvalstarting, _selectedvalorigin, _selectedvalnumerology, _selectedvalrashi, _selectedvalnakshatra, _selectedvalgod, sortkey, pageNo, pageSize, _obj1.metaDetails, _obj1.postDetails);
                
    //         }

    //         if(this.state.articleData.length == 0){
    //             this.articleData();
    //         }

    //         if(this.state.alsoData.length == 0){
    //             this.alsoData();
    //         }

    //         if(this.state.filterData.length == 0){
    //             this.filterData();
    //         }
    //     } else {
    //         if (localStorage.getItem('babynameListing')) {
    //             this.setState(
    //                 { listingData: JSON.parse(localStorage.getItem('babynameListing')) },
    //                 () => { actions.loadSliders(); actions.loadCollectionSlider(); }
    //             );
    //         }

    //         if(localStorage.getItem('articleData')){
    //             this.setState({ articleData: JSON.parse(localStorage.getItem('articleData')) },
    //             () => { actions.loadImages(); actions.loadSliders(); }
    //             );
    //         }

    //         if(localStorage.getItem('alsoData')){                  
    //             this.setState({ alsoData: JSON.parse(localStorage.getItem('alsoData')) });
    //         }

    //         if(localStorage.getItem('filterData')){                  
    //             this.setState({ filterData: JSON.parse(localStorage.getItem('filterData')) });
    //         }
            
            
    //     }
        
    //     window.scrollTo(0,0);
    //     this.setState({window_width : window.innerWidth});
        
    //     actions.loadSliders();
    //     actions.loadCollectionSlider();
    //     actions.loadData();
        
    //     service.showLoader();
    //     setTimeout(function(){
    //         console.log(this.state);
    //         service.hideLoader();
    //     }, 500)
    // }
    
    // componentWillUnmount() {
    //     document.querySelector(".listing_container").removeEventListener("scroll", this.pageData, false);
    //     document.removeEventListener("click", actions.domClick);
    // }
    // pageData() {
    //     var _this = this;
    //     clearTimeout(_this.timeout);
    //     _this.timeout = setTimeout(function () {
    //         if (document.getElementsByClassName('names-list')[0]) {
                
    //             var cS = document.getElementsByClassName('listing_container')[0].offsetTop;
    //             var cH = document.getElementsByClassName('names-list')[0].offsetHeight - 2000,
    //             wS = document.querySelector(".listing_container").scrollTop - cS;
                
    //             if (!((document.querySelector(".listing_container").innerHeight + document.querySelector(".listing_container").scrollTop) >= document.getElementsByClassName('names-list')[0].offsetHeight) && wS > cH) {
    //                 if (wS > _this.maxScroll && _this.totalCount > (_this.disPageNo * 100)) {
    //                     _this.maxScroll = wS;
    //                     ++_this.disPageNo;
    //                     service.showLoader();
    //                     var _urlsrt = window.location.href;
    //                     if(_urlsrt && _urlsrt.includes("?sort")){
    //                         var _sturl = window.location.pathname + "?sort=" + _urlsrt.split("?sort=")[1];
    //                     } else {
    //                         var _sturl = window.location.pathname;
    //                     }
                
    //                     var _selectedvalgender =  "all";
    //                     var _selectedvalnumerology =  "all";
    //                     var _selectedvalorigin =  "all";
    //                     var _selectedvalreligion =  "all";
    //                     var _selectedvalrashi =  "all";
    //                     var _selectedvalnakshatra =  "all";
    //                     var _selectedvalgod =  "all";
    //                     var _selectedvalstarting =  "all";

    //                     var _value_2 = _sturl.split("/")[2];
    //                     _value_2 = _value_2 ? _value_2 : "";
    //                     (_value_2 &&_value_2.includes('?')) ? (_value_2 = _value_2.split('?')[0]) : (_value_2 = _value_2);


    //                     var _value_3 = _sturl.split("/")[3];
    //                     _value_3 = _value_3 ? _value_3 : "";
    //                     (_value_3 &&_value_3.includes('?')) ? (_value_3 = _value_3.split('?')[0]) : (_value_3 = _value_3);
    //                     if(_value_2 !== "search"){
    //                         if(localStorage.getItem('selectedvalgender') != "" && localStorage.getItem('selectedvalgender') != []){
    //                             var temp = [];
    //                             temp.push(localStorage.getItem('selectedvalgender').replace(/[\[\]']+/g,''));
    //                             _selectedvalgender = temp;
    //                         } else {
    //                             _selectedvalgender =  "all";
    //                         }
        
    //                         if(localStorage.getItem('selectedvalnumerology') != "" && localStorage.getItem('selectedvalnumerology') != []){
    //                             var temp = [];
    //                             temp.push(localStorage.getItem('selectedvalnumerology').replace(/[\[\]']+/g,''));
    //                             _selectedvalnumerology = temp;
    //                         } else {
    //                             _selectedvalnumerology =  "all"
    //                         }
        
    //                         if(localStorage.getItem('selectedvalreligion') != "" && localStorage.getItem('selectedvalreligion') != []){
    //                             var temp = [];
    //                             temp.push(localStorage.getItem('selectedvalreligion').replace(/[\[\]']+/g,''));
    //                             _selectedvalreligion = temp;
    //                         } else {
    //                             _selectedvalreligion =  "all"
    //                         }
    //                         if(localStorage.getItem('selectedvalorigin') != "" && localStorage.getItem('selectedvalorigin') != []){
    //                             var temp = [];
    //                             temp.push(localStorage.getItem('selectedvalorigin').replace(/[\[\]']+/g,''));
    //                             _selectedvalorigin = temp;
    //                         } else {
    //                             _selectedvalorigin =  "all"
    //                         }
    //                         if(localStorage.getItem('selectedvalrashi') != "" && localStorage.getItem('selectedvalrashi') != []){
    //                             var temp = [];
    //                             temp.push(localStorage.getItem('selectedvalrashi').replace(/[\[\]']+/g,''));
    //                             _selectedvalrashi = temp;
    //                         } else {
    //                             _selectedvalrashi =  "all"
    //                         }
        
    //                         if(localStorage.getItem('selectedvalnakshatra') != "" && localStorage.getItem('selectedvalnakshatra') != []){
    //                             var temp = [];
    //                             temp.push(localStorage.getItem('selectedvalnakshatra').replace(/[\[\]']+/g,''));
    //                             _selectedvalnakshatra = temp;
    //                         } else {
    //                             _selectedvalnakshatra =  "all"
    //                         }
        
    //                         if(localStorage.getItem('selectedvalgod') != "" && localStorage.getItem('selectedvalgod') != []){
    //                             var temp = [];
    //                             temp.push(localStorage.getItem('selectedvalgod').replace(/[\[\]']+/g,''));
    //                             _selectedvalgod = temp;
    //                         } else {
    //                             _selectedvalgod =  "all"
    //                         }
    //                         if(localStorage.getItem('selectedvalstarting') != "" && localStorage.getItem('selectedvalstarting') != []){
    //                             var temp = [];
    //                             temp.push(localStorage.getItem('selectedvalstarting').replace(/[\[\]']+/g,''));
    //                             _selectedvalstarting = temp;
    //                         } else {
    //                             _selectedvalstarting =  "all"
    //                         }
    //                     } else if(_value_2 == "search"){
    //                         if(localStorage.getItem('selectedvalgender') != "" && localStorage.getItem('selectedvalgender') != []){
    //                             _selectedvalgender = localStorage.getItem('selectedvalgender').split(",");
    //                         } else {
    //                             _selectedvalgender = "all";
    //                         }
    //                         if(localStorage.getItem('selectedvalreligion') != "" && localStorage.getItem('selectedvalreligion') != []){
    //                             _selectedvalreligion = localStorage.getItem('selectedvalreligion').split(",");
    //                         } else {
    //                             _selectedvalreligion = "all";
    //                         }
    //                         if(localStorage.getItem('selectedvalnumerology') != "" && localStorage.getItem('selectedvalnumerology') != []){
    //                             _selectedvalnumerology = localStorage.getItem('selectedvalnumerology').split(",");
    //                         }else {
    //                             _selectedvalnumerology = "all";
    //                         }
    //                         if(localStorage.getItem('selectedvalrashi') != "" && localStorage.getItem('selectedvalrashi') != []){
    //                             _selectedvalrashi = localStorage.getItem('selectedvalrashi').split(",");
    //                         }else {
    //                             _selectedvalrashi = "all";
    //                         }
        
    //                         if(localStorage.getItem('selectedvalnakshatra') != "" && localStorage.getItem('selectedvalnakshatra') != []){
    //                             _selectedvalnakshatra = localStorage.getItem('selectedvalnakshatra').split(",");
    //                         } else {
    //                             _selectedvalnakshatra = "all";
    //                         }
    //                         if(localStorage.getItem('selectedvalstarting') != "" && localStorage.getItem('selectedvalstarting') != []){
    //                         _selectedvalstarting = localStorage.getItem('selectedvalstarting').split(",");
    //                         } else {
    //                             _selectedvalstarting = "all";
    //                         }
    //                         if(localStorage.getItem('selectedvalgod') != "" && localStorage.getItem('selectedvalgod') != []){
    //                         _selectedvalgod = localStorage.getItem('selectedvalgod').split(",");
    //                         } else {
    //                             _selectedvalgod = "all";
    //                         }
    //                         if(localStorage.getItem('selectedvalorigin') != "" && localStorage.getItem('selectedvalorigin') != []){
    //                         _selectedvalorigin = localStorage.getItem('selectedvalorigin').split(",");
    //                         } else {
    //                             _selectedvalorigin = "all";
    //                         }
    //                     }
        
    //                     if(_value_2 == "finder" && _value_3){
    //                         var keyword = _value_3;   
    //                     } else {
    //                         var keyword = "";
    //                     }

    //                     var _obj1 = actions.getBabyNamesData(_sturl, _selectedvalgender, _selectedvalreligion, _selectedvalnumerology, _selectedvalrashi, _selectedvalnakshatra, _selectedvalstarting, _selectedvalgod, _selectedvalorigin, localStorage.getItem('searchedname'));
        
    //                     var gender = _selectedvalgender;
    //                     var religion = _selectedvalreligion;
    //                     var category = "";
                        
    //                     var startwith = _selectedvalstarting;
    //                     var origin = _selectedvalorigin;
    //                     var numerology = _selectedvalnumerology;
    //                     var rashi = _selectedvalrashi;
    //                     var nakshatra = _selectedvalnakshatra;
    //                     var god = _selectedvalgod;
    //                     var pageNo = _obj1.postDetails.pageno;
    //                     var pageSize = 100;
    //                     var sortkey =_obj1.postDetails.sortkey;

    //                     _this.getListing(gender, religion, category, keyword, startwith, origin, numerology, rashi, nakshatra, god, sortkey, _this.disPageNo, pageSize, _obj1.metaDetails, _obj1.postDetails);

    //                 } else {
    //                     return false;
    //                 }
    //             }
    //         }
    //     }, 100)
    // }
    // articleData() {
    //     var postData = {};
    //     var url = global.api_ci_url + "Babynames/getarticlesdata";
    //     service.postServiceCall(url, postData).then((json) => {
    //         if (json['msg'] == "1") {
    //             if (this.state.articleData.length > 0) {
    //                 this.setState({ articleData: json['article'] }, () => {service.loadImages(); actions.loadSliders(); actions.loadCollectionSlider();actions.loadData();})
    //             } else {
    //                 localStorage.setItem('articleData', JSON.stringify(json['article']))
    //                 ;
    //                 this.setState({ articleData: json['article'] }, () => {service.loadImages(); actions.loadSliders(); actions.loadCollectionSlider();actions.loadData();});
    //             }
    //         }
    //     }).catch((error) => {
    //         console.error(error);
    //     });
    // }
    // alsoData() {
    //     var postData = {};
    //     var url = global.api_ci_url + "Babynames/getalsoreaddata";
    //     service.postServiceCall(url, postData).then((json) => {
    //         if (json['msg'] == "1") {
    //             if (this.state.alsoData.length > 0) {
    //                 this.setState({ alsoData: json['AlsoData']}, () => {service.loadImages(); actions.loadSliders(); actions.loadCollectionSlider();actions.loadData();})
    //             } else {
    //                 localStorage.setItem('alsoData', JSON.stringify(json['AlsoData']));                   
    //                 this.setState({ alsoData: json['AlsoData'] }, () => {service.loadImages(); actions.loadSliders(); actions.loadCollectionSlider();actions.loadData();});
    //             }
    //         }
    //     }).catch((error) => {
    //         console.error(error);
    //     });
    // }
    // filterData() {
    //     var postData = {};
    //     var url = global.api_ci_url + "Babynames/getfilterlist";
    //     service.postServiceCall(url, postData).then((json) => {
    //         if (json['filters']) {
    //             if (this.state.filterData.length > 0) {
    //                 this.setState({ filterData: json['filters'] }, () => {service.loadImages(); actions.loadSliders(); actions.loadCollectionSlider();actions.loadData();})
    //             } else {
    //                 localStorage.setItem('filterData', JSON.stringify(json['filters']));                   
    //                 this.setState({ filterData: json['filters'] }, () => {service.loadImages(); actions.loadSliders(); actions.loadCollectionSlider();actions.loadData();});
    //             }
    //         }
    //     }).catch((error) => {
    //         console.error(error);
    //     });
        
    // }
    // getListing(gender, religion, category, keyword, startwith, origin, numerology, rashi, nakshatra, god, sortkey, pageno, size, meta_info, postDetails_info) {

    //     var postData = {
    //         "gender": gender,
    //         "religion": religion,
    //         "category": category,
    //         "keyword" : keyword,
    //         "startwith" : startwith,
    //         "origin" : origin,
    //         "numerology" : numerology,
    //         "rashi" : rashi,
    //         "nakshatra" : nakshatra,
    //         "god" : god,
    //         "pageNo": pageno,
    //         "pageSize" : size,
    //         "sortkey" : sortkey
    //     }
    //     var postForNoData = {
    //         "keyword" : "",
    //         "startwith" : ["W"],
    //         "gender": ["Unisex", "Boy"],
    //         "origin": "",
    //         "religion": ['Hindu'],
    //         "numerology": ["3"],
    //         "rashi": "",
    //         "nakshatra" : ["Aswini"],
    //         "god" : "",
    //         "pageNo" : "1",
    //         "pageSize" : "15",
    //         "sortkey" : "Most Popular"
    //     }
    //     service.showLoader();

    //     var url = global.api_ci_url +"Babynames/getbabysearchbyfilters";
    //     service.postServiceCall(url, postData).then((json) => {
    //         if (json['msg'] === "1") {
    //             if (this.state.listingData.length > 0 ) {
    //                 if (size == (pageno * 100)) {
    //                     this.setState({ listingData: json['SearchData'], totalResult: json['totalresult']},()=>{
    //                         service.loadImages();
    //                         actions.loadSliders();
    //                         actions.loadCollectionSlider();
    //                         actions.loadData();
    //                     });
                        
    //                 } else {
    //                     let ary = this.state.listingData;
    //                     this.setState({ listingData: ary.concat(json['SearchData']), totalResult: json['totalresult']},()=>{
    //                         service.loadImages();
    //                         actions.loadSliders();
    //                         actions.loadCollectionSlider();
    //                         actions.loadData();
    //                     })
    //                 }
    //             } else {
    //                 localStorage.setItem('babynameListing', JSON.stringify(json['SearchData']));
    //                 this.setState({ listingData: json['SearchData'], totalResult: json['totalresult'] }, () => {service.loadImages(); actions.loadSliders(); actions.loadCollectionSlider();actions.loadData();});
    //                 this.totalCount = json['totalresult'];
                    
    //                 // var _pgntion = actions.pagination(100, Number(pageno), window.location.pathname, Number(this.totalCount),'');
    //                 // this.setState({ paginationData : _pgntion });
    //             }
    //         } else if(json['msg'] === "-1"){
    //             if (this.state.noDataContent.length > 0) {
    //                 this.setState({ noDataContent: json['categoryList']}, () => {service.loadImages(); actions.loadSliders(); actions.loadCollectionSlider();actions.loadData();})
    //             } else {
    //                 localStorage.setItem('nodatacontent', JSON.stringify(json['categoryList']));
                    
    //                 this.setState({ noDataContent: json['categoryList']}, () => {service.loadImages(); actions.loadSliders(); actions.loadCollectionSlider();});
    //             }
    //             this.setState({ listingData: []});
    //             this.setState({ totalResult: ''});
    //         }

    //         var _breadcrum_1 = postDetails_info._breadcrum_1;
    //         var _breadcrum_2 = postDetails_info._breadcrum_2;

    //         this.setState({ breadcrum_1 : _breadcrum_1 })
    //         this.setState({ breadcrum_2 : _breadcrum_2 });

    //         if(json['totalresult']){
    //             var updated_title = meta_info.pgtitle.replace(/100+/g, json['totalresult']).replace(/[+]/g, '');
    //         } else {
    //             var updated_title = meta_info.pgtitle.replace(/100+/g, '').replace(/[+]/g, '');
    //         }

    //         if(json['totalresult']){
    //             this.setState({headingData : meta_info.heading});
    //             this.setState({metaTitle : updated_title});
    //             this.setState({metaDescription :  [{ "name": "description", "content": meta_info.metadesc},
    //             { "name": "keywords", "content": meta_info.keywords },
    //             { "name": "robots", "content": "all" }]});
    //             this.setState({descTxt : postDetails_info._descText.replace(/100+/g, json['totalresult']).replace(/[+]/g, '')})
    //        } else {
    //             this.setState({headingData : "Baby Names"});
    //             this.setState({metaTitle : "Baby Names List: Find 100000+ Baby Names for Boys & Girls"});
    //             this.setState({metaDescription :  [{ "name": "description", "content": "Find the latest, most popular and unique baby names for your newborn from a list of 100000+ Baby Boy & Girl Names ideas with FirstCry’s Baby Names Finder." },
    //             { "name": "keywords", "content": "baby names, unique baby names, popular baby names" },
    //             { "name": "robots", "content": "all" }]});
    //             this.setState({descTxt : ""})
    //        }
    //        service.hideLoader();
    //     }).catch((error) => {
    //         console.error(error);
    //     });
    // }
    checkGender(gender){
        if(gender == "Boy") {
            return (<span className="gender-icon icon left boy_icon" data-icon-font="&#xe022;"></span>)
        } else if(gender == "Girl"){ 
            return (<span className="gender-icon icon left girl_icon" data-icon-font="&#xe01f;"></span>)
        } else{
            return (<span className="gender-icon icon left unisex_icon" data-icon-font="&#xe029;"></span>)
        }
    }
    isShortList(shortList, recordid, favouriteid, babyname){
        if(shortList == true){
           return (
               <div className="right">
                   <form method="post" action-xhr={`${global.hosturl}parenting/BabynamesAmp/savefavouritename`} encType="application/json">
                        <input type="hidden" name="recordId" value={recordid} />
                        <input type="hidden" name="favouriteId" value={favouriteid} />
                        <input type="hidden" name="action_status" value="0" />
                        <input type="hidden" name="eleName" value={babyname} />

                        <input type="hidden" name="headerdata" value={ 'ftk:' + global.ftk + ',,uid:' + global.uID + ',,access-token:' + global.accessToken+',,user-agent:' + global.userAgent + ',,isdesktop:' + global.isdesktop}/>
                                                
                        <input type="hidden" name="currentUrl" value={global.currentURL}/>

                        <label htmlFor={`heartClk${recordid}`}>
                            <input type="submit" role="button" name="removefromlist" id={`heartClk${recordid}`} tabIndex="0" value="" /> 

                            <div className="success-msg" submit-success="">
                                
                                <template type="amp-mustache" >
                                    <div className="alertMsgoverlay_removedfromlist">
                                        <span className="alertmsg">Successfully removed</span>
                                    </div>
                                </template>
                            </div>
                            <div className="error-msg" submit-error="">
                                <template type="amp-mustache">
                                Error!, please try again.
                                </template>
                            </div>
                            <span className="heart-icon isChecked right" id="dev_lst_hrt_1" data-icon-font="}"></span>
                        </label>
                    </form>
               </div>
           )
        } else {
            return (
                <div className="right">
                    {   (global.ftk) ?
                        <span className="heart-icon right" id="dev_lst_hrt" data-icon-font="+" tabIndex="0" role="button" on={`tap:collection-list-popup.show,collection-part1.show,new-collection.hide,AMP.setState({eleRecord:'${recordid}',eleName:'${babyname}'})`}></span>
                        :
                       
                        <div tabIndex="0" role="button" on="tap:loginToggle.restart">
                            <a href={`${global.loginUrl}?URL=${global.currentURL}`} tabIndex="0" role="button">
                                <span className="heart-icon right" data-icon-font="+"></span>
                            </a>
                            <div className="alertMsgoverlay">
                                <span className="alertmsg">Please Login</span>
                            </div>
                        </div>
                    }
                </div>
            )
        }
    }
    // heartclick(event, recordId, nametoAdd) {
    //  if (!global.ftk) {
    //      service.showAlert("Please Login");
    //      window.location.href = global.loginUrl + '?URL=' + global.currentURL;
    //  } else {
    //      if(event.target.classList.contains('heartselected')){
    //         event.target.setAttribute("data-icon-font", "+")
    //         event.target.className = event.target.className.replace(/\heartselected\b/, "");
    //      } else {
    //          document.querySelector('.collection-part1').style.display = "block";
    //          document.querySelector('.new-collection').style.display = "none";
    //          document.querySelector('.collection-list-popup').style.display = "block";
    //         //  document.querySelector("body").style.overflow = "hidden";
    //          event.target.className += " openpopup";
 
    //          var favouriteId = "";
    //          recordID = recordId;
    //          babynametoadd = nametoAdd;
    //      }
    //      var postData = {
    //          "pageSize": "10",
    //          "pageNo": 1
    //      }
    //      var url =  global.api_ci_url + "Babynames/getmyfavouritelist";

    //      service.postServiceCall(url, postData).then((json) => {
             
    //          if(json['FinalResponse'] !== 'Records Not Found'){
               
    //             this.setState({collectionListData : json['FinalResponse']},);
    //             document.querySelector(".collection-part1").querySelector(".list").style.display = "block";
    //          } else {
    //             document.querySelector(".norecord-overlay").style.display = "block";
    //             // document.querySelector(".collection-part1").querySelector(".list").style.display = "none";
    //          }
    //          service.loadImages();
    //          actions.loadSliders();
    //          service.hideLoader();
    //      }).catch((error) => {
    //          console.error(error);
    //          service.hideLoader();
    //      });
         
    //  }
    // }

    // selectlist(recordId, collectionId, babyname) {
    //     var postData = {
    //         "recordId" : recordId,
    //         "collectionId" : collectionId,
    //         "favouriteId" : "",
    //         "action_status" : "1",
    //     }
    //     var url = global.api_ci_url + "Babynames/savefavouritename";
    //     service.postServiceCall(url, postData).then((json) => {
    //         service.hideLoader();
    //         if(json['msg'] == "1"){
    //             document.querySelector('.collection-list-popup').style.display = "none";
    //             document.querySelector(".nm-add span").innerHTML = babyname + " has been added to list";
    
    //             document.querySelector(".name-added").classList += " add_show";
    //             setTimeout(() => {
    //                 document.getElementsByClassName('name-added')[0].className = document.getElementsByClassName('name-added')[0].className.replace(/\add_show\b/, "");
    //             }, 1000);
                
    //             setTimeout(() => {
    //                 var tempArray = this.state.listingData;

    //                for(var i = 0; i < tempArray.length; i++){
                       
    //                     if(tempArray[i].recordid == recordId){ 
    //                         tempArray[i].isShortlist = true;
    //                         tempArray[i].favouriteid = json['result'];
    //                     }   
    //                 }
    //                 this.setState({ listingData: tempArray});
                
    //             }, 500);
                                
    //         }
    //     }).catch((error) => {
    //         console.error(error);
    //         service.hideLoader();
    //     });
    // }
    // createNewCollection(event, elem) {
    //     var collectionName = event.target.parentElement.parentElement.querySelector(".input-name").value;
    //     if(/<(.|\n)*?>/g.test(collectionName)){
    //         event.target.parentElement.previousSibling.innerHTML = 'Script tags not allowed';
    //         event.target.parentElement.previousSibling.style.display = "block";
    //         event.target.parentElement.parentElement.querySelector(".input-name").value = '';
    //     }else{
    //         if (collectionName.trim() != "" & collectionName.length <= 100) {
    //             var postData = 
    //             {
    //                 "collection" : collectionName,
    //                 "pageNo" : 1,
    //                 "pageSize" : 10
    //             };
    //             var url = global.api_ci_url + "Babynames/postcollection";

    //             service.postServiceCall(url, postData).then((json) => {
    
    //                 document.querySelector('.collection-list-popup').style.display = "none";
    //                 document.getElementsByTagName('body')[0].style.overflow = "auto";
    //                 if (json['msg'] == "1") {
    //                     elem.selectlist(recordID, json['result'], babynametoadd);
    //                 } else {
    //                     document.querySelector(".nm-add span").innerHTML = collectionName + "already exists";
    //                     document.querySelector(".name-added").classList += " add_show";
                  
    //                     setTimeout(() => {
    //                         document.getElementsByClassName('name-added')[0].className = document.getElementsByClassName('name-added')[0].className.replace(/\add_show\b/, "");
    //                     }, 1000);
    //                 }
    //                document.querySelector(".input-name").value = '';
    
    //             }).catch((error) => {
    //                 console.error(error);
    //                 service.hideLoader();
    //             });
    //         } else {
    //             event.target.parentElement.previousSibling.innerHTML = "Max 100 characters are allowed";
    //             event.target.parentElement.previousSibling.style.display = "block";
    //             document.querySelector(".input-name").value = '';
    //         }
    //     }
    // }
    
    // CollectionListPopup(eleRef, eleRecord, eleName, elem) {

    
    //     // if(eleRef.length > 0){
    //     //     document.querySelector(".collection-part1").querySelector(".list").style.display = "block";
    //     // }
    //     var items = [];
    //     [].forEach.call(eleRef, function (value, key) {
    //         items.push(<li key={key} className="dev_selcoll" onClick={(e) => elem.selectlist(`${eleRecord}`, `${value.coll_id}`, `${eleName}`)}>
    //             <div className="baby_img">
    //                 <img src="http://cdn.fcglcdn.com/brainbees/apps/image/baby_name_icon.png" className="dev_selcollimg" />
    //             </div>
    //             <div className="M14_42">
    //                 <span className="coll_title"> {value.coll_name} </span>
    //             </div>
    //             <div className="M14_pink">
    //                 <span className="dev_selcoll"> {value.count} </span>
    //                 <span className="dev_selcolltxt"> Name(s) </span>
    //             </div>
    //         </li>
    //         )
    //     });
         
    //     return (
            
    //             <div className="collection-list-popup" id="collection-list-popup" hidden>
    //                 <div className="collection" onClick={(e) => this.collection_click()}>
    //                     <div className="collection-part1" id="collection-part1" hidden>
    //                         <span className="selct-title M18_42"> Select the collection list </span>
    //                         <span className="create-ic right" onClick={() => actions.createlist()} >
    //                             Create + 
    //                         </span>
    //                         <div className="list" id="list">
    //                             <ul className="collection-list" data-count={eleRef.length}>{items}</ul>
    //                         </div>
    //                         <span className="next" onClick={() => service.slideSlider('list', 300, 1000)}>
    //                             <span data-icon-font="h" className="icon"></span>
    //                         </span>
    //                         <span className="prev" onClick={() => service.slideSlider('list', -300, 1000)}>
    //                             <span data-icon-font="g" className="icon"></span>
    //                         </span>
    //                     </div>
    //                     { /*<!--norecord starts--> */}
    //                     <div className="norecord-overlay left">
    //                         <div className="norecord_alert">
    //                             <div className="M16_42">  No collection list created yet. </div>
    //                             <div className="R14_9e"> Please create the one to shortlist the cute baby names.
    //                             </div>
    //                         </div>
    //                     </div>
    //                     { /*<!--norecord ends--> */}
    //                     <div className="new-collection" id="new-collection" hidden>
    //                         <div className="selct-title  M18_42"> Create New Collection </div>
    //                         <span className="M14_42"> Collection Name </span>
    //                         <input type="text"
    //                             placeholder="Family's, Father, Mother"
    //                             className="input-name"/>
    //                         <span className="error_msg R11_red"> </span>
    //                         <div className="popup-btns right">
    //                             <span className="cancel-popup M14_9e" onClick={(e) => actions.cancelCreate_popup(e)}> CANCEL </span>
    //                             <span className="M14_pink dev_create_addfavname" onClick={(e) => this.createNewCollection(e, this)}>
    //                                 CREATE 
    //                             </span>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
            
    //     )
    // }
    // NoData(){
    //     var item = [];
    //     var _caturl = '';
    //     this.state.noDataContent.map((value, index) => {
    //         _caturl = value.category_name;
            
    //         item.push(<li className="left" key={index}>
    //             <span onClick={(e) => actions.toListingPage(`${value.category_name}`, `${value.cat_filter[0].key}`, `${value.cat_filter[1].key}`, `${value.cat_filter[2].key}`, this)} >
    //                 <span className="R14_42">{_caturl}</span>
    //                 <span className="R14_9e icon right" data-icon-font="l"></span>
    //             </span>
    //         </li>);
    //         }
    //     )
    //     return (
    //         <div className="no_record_page">
    //             <div className="R15_9e try_another_name">Try searching for other term</div>
    //             <div className="M14_42 browse_names">Browse our popular Categories</div>
    //             <ul className="left">
    //                 {item}
    //             </ul>
    //         </div>
    //     );
    // }
   
    // hideSort(){
    //     document.querySelector('.sort-list-popup').style.display = "none";
    //     document.querySelector("body").style.overflow = "unset";
    // }
    // collection_click() {
    //     document.querySelector('.collection-list-popup').style.display = "block";
    //     // document.querySelector("body").style.overflow = "hidden";
    // }

    // removeFromColl(recordId, favId, babyname, event){
    //     if(navigator.onLine){
    //         if (favId == "0") {
    //             var favouriteId = event.target.getAttribute("data-favid");
    //         } else {
    //             var favouriteId = favId;
    //         }
    //         var postData = {   
    //             "favouriteId" : favouriteId,
    //             "recordId": recordId,
    //             "collectionId": "",
    //             "action_status": "0"
    //         };
        
    //         var currentEle = event.target;
    //         var url = global.api_ci_url + "Babynames/savefavouritename";
    //         service.postServiceCall(url, postData).then((json) => {
    //             service.hideLoader();
    //             if(json['msg'] == "1"){
    //                 setTimeout(() => {
    //                     var tempArray = this.state.listingData;
    //                 for(var i = 0; i < tempArray.length; i++){
                        
    //                         if(tempArray[i].recordid == recordId){ 
    //                             tempArray[i].isShortlist = false;
    //                             tempArray[i].favouriteid = 0;
    //                         }   
    //                     }
    //                     this.setState({ listingData: tempArray});
    //                 }, 500);

    //                 document.querySelector(".nm-add span").innerHTML = babyname + ' has been removed from list';
    //                 document.querySelector(".name-added").classList += " add_show";
                        
    //                 setTimeout(() => {
    //                     document.getElementsByClassName('name-added')[0].className = document.getElementsByClassName('name-added')[0].className.replace(/\add_show\b/, "");
    //                 }, 1000);

    //             } else {
    //                 window.location.href = service.getRedirectUrl(currentURL);
    //             }
    //         }).catch((error) => {
    //             console.error(error);
    //             service.hideLoader();
    //         });
    //     } else {
    //         service.showAlert("Please check internet connection!!!");
    //     }
    // }

    // reloadData() {
    //     var _this = this;
    //     // setTimeout(() => {
    //         service.showLoader();
    //         var _urlsrt = window.location.href;
    //         if(_urlsrt && _urlsrt.includes("?sort")){
    //             var _sturl = window.location.pathname + "?sort=" + _urlsrt.split("?sort=")[1];
    //         } else {
    //             var _sturl = window.location.pathname;
    //         }
            
    //         var _selectedvalgender =  "all";
    //         var _selectedvalnumerology =  "all";
    //         var _selectedvalorigin =  "all";
    //         var _selectedvalreligion =  "all";
    //         var _selectedvalrashi =  "all";
    //         var _selectedvalnakshatra =  "all";
    //         var _selectedvalgod =  "all";
    //         var _selectedvalstarting =  "all";
            
    //         if(_sturl.split("/")[2] !== "search"){
    //             if(localStorage.getItem('selectedvalgender')){
    //                 var temp = [];
    //                 temp.push(localStorage.getItem('selectedvalgender'));
    //                 _selectedvalgender = temp;
    //             } else {
    //                 _selectedvalgender =  "all";
    //             }

    //             if(localStorage.getItem('selectedvalnumerology')){
    //                 var temp = [];
    //                 temp.push(localStorage.getItem('selectedvalnumerology'));
    //                 _selectedvalnumerology = temp;
    //             } else {
    //                 _selectedvalnumerology =  "all"
    //             }

    //             if(localStorage.getItem('selectedvalreligion')){
    //                 var temp = [];
    //                 temp.push(localStorage.getItem('selectedvalreligion'));
    //                 _selectedvalreligion = temp;
    //             } else {
    //                 _selectedvalreligion =  "all"
    //             }
    //             if(localStorage.getItem('selectedvalorigin')){
    //                 var temp = [];
    //                 temp.push(localStorage.getItem('selectedvalorigin'));
    //                 _selectedvalorigin = temp;
    //             } else {
    //                 _selectedvalorigin =  "all"
    //             }
    //             if(localStorage.getItem('selectedvalrashi')){
    //                 var temp = [];
    //                 temp.push(localStorage.getItem('selectedvalrashi'));
    //                 _selectedvalrashi = temp;
    //             } else {
    //                 _selectedvalrashi =  "all"
    //             }


    //             if(localStorage.getItem('selectedvalnakshatra')){
    //                 var temp = [];
    //                 temp.push(localStorage.getItem('selectedvalnakshatra'));
    //                 _selectedvalnakshatra = temp;
    //             } else {
    //                 _selectedvalnakshatra =  "all"
    //             }

    //             if(localStorage.getItem('selectedvalgod')){
    //                 var temp = [];
    //                 temp.push(localStorage.getItem('selectedvalgod'));
    //                 _selectedvalgod = temp;
    //             } else {
    //                 _selectedvalgod =  "all"
    //             }
    //             if(localStorage.getItem('selectedvalstarting')){
    //                 var temp = [];
    //                 temp.push(localStorage.getItem('selectedvalstarting'));
    //                 _selectedvalstarting = temp;
    //             } else {
    //                 _selectedvalstarting =  "all"
    //             }
    //         } else if(_sturl.split("/")[2] == "search"){
    //             if(localStorage.getItem('selectedvalgender')){
    //                 _selectedvalgender = localStorage.getItem('selectedvalgender').split(",");
    //             } else {
    //                 _selectedvalgender = "all";
    //             }
    //             if(localStorage.getItem('selectedvalreligion')){
    //                 _selectedvalreligion = localStorage.getItem('selectedvalreligion').split(",");
    //             } else {
    //                 _selectedvalreligion = "all";
    //             }
    //             if(localStorage.getItem('selectedvalnumerology')){
    //                 _selectedvalnumerology = localStorage.getItem('selectedvalnumerology').split(",");
    //             }else {
    //                 _selectedvalnumerology = "all";
    //             }
    //             if(localStorage.getItem('selectedvalrashi')){
    //                 _selectedvalrashi = localStorage.getItem('selectedvalrashi').split(",");
    //             }else {
    //                 _selectedvalrashi = "all";
    //             }

    //             if(localStorage.getItem('selectedvalnakshatra')){
    //                 _selectedvalnakshatra = localStorage.getItem('selectedvalnakshatra').split(",");
    //             } else {
    //                 _selectedvalnakshatra = "all";
    //             }
    //             if(localStorage.getItem('selectedvalstarting')){
    //             _selectedvalstarting = localStorage.getItem('selectedvalstarting').split(",");
    //             } else {
    //                 _selectedvalstarting = "all";
    //             }
    //             if(localStorage.getItem('selectedvalgod')){
    //             _selectedvalgod = localStorage.getItem('selectedvalgod').split(",");
    //             } else {
    //                 _selectedvalgod = "all";
    //             }
    //             if(localStorage.getItem('selectedvalorigin')){
    //             _selectedvalorigin = localStorage.getItem('selectedvalorigin').split(",");
    //             } else {
    //                 _selectedvalorigin = "all";
    //             }
    //         }

    //         var _obj1 = actions.getBabyNamesData(_sturl, _selectedvalgender, _selectedvalreligion, _selectedvalnumerology, _selectedvalrashi, _selectedvalnakshatra, _selectedvalstarting, _selectedvalgod, _selectedvalorigin, localStorage.getItem('searchedname'));

    //         var gender = _selectedvalgender;
    //         var religion = _selectedvalreligion;
    //         var category = "";
    //         var keyword = "";
    //         var startwith = _selectedvalstarting;
    //         var origin = _selectedvalorigin;
    //         var numerology = _selectedvalnumerology;
    //         var rashi = _selectedvalrashi;
    //         var nakshatra = _selectedvalnakshatra;
    //         var god = _selectedvalgod;
    //         var pageNo = 1;
    //         var pageSize = 100;
    //         var sortkey =_obj1.postDetails.sortkey;

    //         this.getListing(gender, religion, category, keyword, startwith, origin, numerology, rashi, nakshatra, god, sortkey, pageNo, pageSize, _obj1.metaDetails, _obj1.postDetails);
                
    //         // service.hideLoader();
    //     // }
    // }
    pagination(){
        if(global.currentURL.includes("/page/")){
            var primary_url = global.currentURL.split("page/")[0];

            // [0]/baby-names/boy/
            // [1]4/amp/
            // /baby-names/boy/page/4/amp/ -> /baby-names/boy/page/3/amp/

        } else {
            var primary_url = global.currentURL.split("amp/")[0];
            // /baby-names/boy/amp/
            // [0]/baby-names/boy/
            // [1] ''
            // /baby-names/boy/amp/ -> /baby-names/boy/page/2/amp/
        }

        let pages = [];
        if(this.disPageNo > 1){
            var currentUrl = primary_url + "page/" + (Number(this.disPageNo)-1) + "/amp/";
            pages.push(
                <li key="prev" className="nextprev">
                    
                    <a href={service.getRedirectUrl(`${currentUrl}`)}>
                        Previous
                    </a>
                </li>
            )
        }
        if(this.disPageNo < 5){
            for(let i = 1; i <= this.totalpages; i++){
                if(i <= 5){
                    if (this.disPageNo == i) {
                        pages.push(
                            <li key={`page_${i}`} className="activepage">
                                {i}
                            </li>
                        )
                    }
                    else {
                        var currentUrl = primary_url + "page/" + (i) + "/amp/";
                        
                        pages.push(
                            <li key={`page_${i}`} className="page">
                                <a href={service.getRedirectUrl(`${currentUrl}`)}>
                                    {i}
                                </a>
                            </li>
                        )
                    }
                }
            }
        } 
        else {
            for(let i = this.disPageNo - 2; i <= this.totalpages; i++){
                if(i <= this.disPageNo + 2){
                    if (this.disPageNo == i) {
                        pages.push(
                            <li key={`page_${i}`} className="activepage">
                                {i}
                            </li>
                        )
                    }
                    else {
                        var currentUrl = primary_url + "page/" + (i) + "/amp/";
                        
                        pages.push(
                            <li key={`page_${i}`} className="page">
                                <a href={service.getRedirectUrl(`${currentUrl}`)}>
                                    {i}
                                </a>
                            </li>
                        )
                    }
                }
            }
        }
        if((this.disPageNo) != this.totalpages){
            var currentUrl = primary_url + "page/" + (Number(this.disPageNo)+1) + "/amp/";
            
            pages.push(
                
                <li key="next" className="nextprev">
                    <a href={service.getRedirectUrl(`${currentUrl}`)}>
                        Next
                    </a>
                </li>
            )
        }
        return pages;
    }
    render() {
        
        let jsonArticle = this.state.articleData;
        let jsonAlsoData = this.state.alsoData;
        let _heading = this.state.headingData;
        var noData_ = this.state.noDataContent;
        
        function NoData(){
            var item = [];
            var _caturl = '';
            noData_.map((value, index) => {
                _caturl = value.category_name;
                var _urlToredirect = actions.toListingPage(`${value.category_name}`, `${value.cat_filter[0].key}`, `${value.cat_filter[1].key}`, `${value.cat_filter[2].key}`);

                item.push(<li className="left" key={index}>
                    <a href={_urlToredirect} target="_self">
                        <span className="R14_42">{_caturl}</span>
                        <span className="R14_9e icon right" data-icon-font="l"></span>
                    </a>
                </li>);
                }
            )
            return (
                <div className="no_record_page">
                    <div className="R15_9e try_another_name">Try searching for other term</div>
                    <div className="M14_42 browse_names">Browse our popular Categories</div>
                    <ul className="left">
                        {item}
                    </ul>
                </div>
            );
        }
   
        return (
            <main className="baby-names-main main-container">
                <div className="title mobile_listing_title">
                    <div className="breadcrumb R11_9e">
                        <span><a className="R11_9e" href={service.getRedirectUrl("/amp/")}>Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a className="R11_9e" href={service.getRedirectUrl("/baby-names/amp/")}>Baby Names</a></span>
                        {
                            (this.state.breadcrum_1 !== "" && this.state.breadcrum_2 !== "") ? 
                            (
                                <span>
                                    <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                                    <span>
                                        <a className="R11_9e" href={service.getRedirectUrl(`/baby-names/${this.state.breadcrum_1.toLowerCase()}/amp/`)}>{this.state.breadcrum_1}
                                        </a>
                                    </span>
                                    <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                                    <span>{this.state.breadcrum_2}</span>
                                </span>
                            ) :
                            (
                                (this.state.breadcrum_1 !== "" && this.state.breadcrum_2 == "") ?
                                (
                                    <span>
                                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                                        <span>{this.state.breadcrum_1}</span>
                                    </span>
                                ) :
                                (
                                    (this.state.breadcrum_1 == "" && this.state.breadcrum_2 !== "") ?
                                    (
                                        <span>
                                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                                            <span>{this.state.breadcrum_2}</span>
                                        </span>
                                    ) :
                                    ''
                                )
                            )
                        }
                    </div>
                </div>
                <meta name="atdlayout" content="babynames_ap" />
                <div className="baby-names-head">
                        <div className="mobile_listing">
                            <a href={service.getRedirectUrl(`/baby-names/amp/`)} title=""><span className="icon" data-icon-font="s"></span></a>
                                <span className="M16_white header_babynm">
                                {
                                    this.state.isReligionOrigin ? 
                                    'Baby Names' : 
                                    (this.state.totalResult ? 
                                        ('Baby Names (Results ' + (this.state.totalResult) + ')') :
                                        'Baby names'
                                    )
                                }
                                </span>
                            <span className="head-icons right">
                                {/* {
                                    this.state.isReligionOrigin ? 
                                    '' :
                                    <span className="sort-ic" data-icon-font="," tabIndex="0" role="button" on="tap:sort-list-popup.toggleVisibility"></span>
                                } */}
                                
                                <span className="filter-ic" data-icon-font="K" tabIndex="0" role="button" on="tap:filter_popup_overlay.show,subgender.hide,subreligion.hide,suborigin.hide,subnumerology.hide,subrashi.hide,subnakshatra.hide,substartwith.hide,subgod.hide, subgender.show"></span>
                            </span>
                        </div>
                        
                        <div className="list_heading">
                            <h1 className="B23_21 desktop_heading">
                                {_heading}
                            </h1>
                            
                            <span className="head-icons right">
                                {/* {
                                    this.state.isReligionOrigin ? 
                                    '' :
                                    <div className="left sort_cont" tabIndex="0" role="button" on="tap:sort-list-popup.toggleVisibility">
                                        <span className="sort-ic" data-icon-font=","></span>
                                        <span className="R16_42 sort_filter_text" id="dev_so_rt">Sort</span>
                                    </div>
                                }
                                 */}
                                <div className="right" tabIndex="0" role="button" on="tap:filter_popup_overlay.show,subgender.hide,subreligion.hide,suborigin.hide,subnumerology.hide,subrashi.hide,subnakshatra.hide,substartwith.hide,subgod.hide, subgender.show">
                                    <span className="filter-ic" data-icon-font="K"></span>
                                    <span className="R16_42 sort_filter_text">Filter</span>
                                </div>
                            </span>
                        </div>
                </div>

                <div className="sub-container left">
                    <div className="baby-names-list">
                        <div className="data-container left landing">
                       
                            {
                                // (((this.props.location.pathname.split("/")[2] == "religion" || this.props.location.pathname.split("/")[2] == "origin") && (this.props.location.pathname.split("/")[3] == "")) || (this.props.location.pathname.split("/")[2] == "boy" || this.props.location.pathname.split("/")[2] == "girl" || this.props.location.pathname.split("/")[2] == "unisex") || (this.props.location.pathname.split("/")[4] == "starting-with" || this.props.location.pathname.split("/")[5] == "starting-with")) ?

                                // '' :
                                // (
                                    (this.state.descTxt != '' && !this.props.location.pathname.includes("page")) ?

                                    (<div className="list_info list_info_forDesk">
                                        <div className="">
                                            <span className="R14_75 baby_name_finder_text">
                                                {
                                                    this.state.descTxt 
                                                }
                                            </span>
                                        </div>
                                        {/* <div className="readmore_popup">
                                            <div className="readmorelink R14_link" onClick={(e) => actions.readmoreClick(e, '.list_info', '.discussion-readless', '40px')}>Read More</div>
                                        </div> */}
                                    </div>)
                                     :
                                    ''
                                    // )
                            }
                           
                            <div className="listing_container">
                                {
                                    (this.state.listingData && this.state.listingData.length > 0) ?
                                    (((this.props.location.pathname.split("/")[2] == "religion" || this.props.location.pathname.split("/")[2] == "origin") && ( this.props.location.pathname.split("/")[3] == "amp")) ?
                                        (
                                            <div className="no_record_page allorigins">
                                                <div className="list_name_description forMob">
                                                
                                                    <h1 className="M18_42 mobile_heading">
                                                        {this.state.headingData}
                                                    </h1>
                                                </div>
                                            
                                            <ul className="left">
                                            {(
                                                (this.props.location.pathname.split("/")[2] == "origin") ? 
                                                ((this.state.filterData[2] != undefined) ?
                                                (this.state.filterData[2].values.map((value, index) => 
                                                        (<li className="left" key={index} onClick={(e) => actions.toOriginNames(e, value.key)}>
                                                            <a href={service.getRedirectUrl(`/baby-names/origin/${value.key.split(" ")[0].toLowerCase()}/amp/`)} >
                                                                <span className="R14_42">{`${value.key} Baby Names`}</span>
                                                                <span className="R14_9e icon right" data-icon-font="l"></span>
                                                            </a>
                                                        </li>)
                                                    )
                                                ) : 
                                                ''
                                                )
                                                :
                                                (this.state.filterData[1] != undefined) ?
                                                
                                                (this.state.filterData[1].values.map((value, index) => 
                                                    (<li className="left" key={index} className="left" onClick={(e) => actions.toReligionNames(e, value.key)}>
                                                        <a href={service.getRedirectUrl(`/baby-names/religion/${value.key.split(" ")[0].toLowerCase()}/amp/`)}>
                                                            <span className="R14_42">{`${value.key} Baby Names`}</span>
                                                            <span className="R14_9e icon right" data-icon-font="l"></span>
                                                        </a>
                                                    </li>)
                                                    
                                                )) :
                                                ''
                                            )}
                                            </ul>
                                            </div>
                                        )
                                        :
                                        (
                                            <div className="">
                                            
                                            <div className="list_name_description forMob">
                                                <h1 className="M18_42 mobile_heading">
                                                    {this.state.headingData}
                                                </h1>
                                                {
                                                    (this.state.descTxt != '' && !this.props.location.pathname.includes("page")) ? 
                                                    (
                                                        <div>
                                                            <div className="list_desc">
                                                                <span className="R14_75 baby_name_finder_text">
                                                                    {this.state.descTxt}
                                                                </span>
                                                            </div>
                                                            {/* <div className="readmore_popup" style={{display: "block"}}>
                                                                <div className="readmorelink R14_link" onClick={(e) => actions.readmoreClick(e, '.list_name_description', '.discussion-readless', '40px')}>Read More</div>
                                                            </div> */}
                                                        </div>
                                                    ) :
                                                    ''
                                                }
                                            </div>

                                            <ul className="names-list">
                                                
                                                {this.state.listingData && this.state.listingData.map((value, index) => 
                                                    ( 
                                                        <li key={index} id={value.recordid}>
                                                             <form method="post" action-xhr={`${global.hosturl}parenting/BabynamesAmp/tonameDetails`} encType="application/json"  className="name-info">
                                                                <input type="hidden" name="Babyname" value={value.babyname}/>
                                                                <input type="hidden" name="BabynameId" value={value.recordid}/>
                                                                <label htmlFor={`name${value.recordid}`}>
                                                                    <div className="curs_pointer">
                                                                        {this.checkGender(value.gender)}
                                                                        { (this.props.location.pathname.split("/")[2] == "girl") ?
                                                                        <div className="names" id="dev_girls">
                                                                            <div className="baby-name M15_42">{value.babyname}</div>
                                                                            <span className="nm-ming R12_9e">{value.meaning}</span>
                                                                        </div> :
                                                                        <div className="names" id="dev_boys">
                                                                        <div className="baby-name M15_42">{value.babyname}</div>
                                                                        <span className="nm-ming R12_9e">{value.meaning}</span>
                                                                       </div>
                                                                        }
                                                                    </div>
                                                                </label>
                                                                <input type="submit" value="" hidden id={`name${value.recordid}`}/>
                                                            </form>
                                                            {this.isShortList(value.isShortlist, value.recordid, value.favouriteid, value.babyname)}

                                                            
                                                            {gptAry[index + 1] &&
                                                                <div>
                                                                    <div className="desktop-ads-block">
                                                                        <div id={gptAry[index + 1]['desktop']['id']} style={{ width: '696px', height: '200px', overflow: 'hidden', margin: '0 auto' }}>
                                                                            <GPT
                                                                                adUnitPath={gptAry[index + 1]['desktop']['path']}
                                                                                slotSize={gptAry[index + 1]['desktop']['slot']}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="msite-ads-block">
                                                                        <div id={gptAry[index + 1]['msite']['id']} style={{ width: '320px', height: '50px', overflow: 'hidden', margin: '0 auto' }}>
                                                                            <GPT
                                                                                adUnitPath={gptAry[index + 1]['msite']['path']}
                                                                                slotSize={gptAry[index + 1]['msite']['slot']}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </li>
                                                       
                                                        )
                                                    )
                                                }
                                            </ul>

                                            <div className="pagination-cnt">
                                                <ul>
                                                    {this.pagination()}
                                                </ul>
                                            </div>
                                        </div>
                                        )
                                    )
                                    :
                                    NoData()
                                }
                            </div>
                            {(this.props.location.pathname.split("/")[2] !== "finder") ?
                                
                                (<div className="also_read_container">
                                    <h2 className="also_read M18_42">Explore More in Baby Names</h2>
                                    {
                                        (this.props.location.pathname.split("/")[2] == "boy" || this.props.location.pathname.split("/")[2] == "girl") ?
                                            (<ul className="">
                                                <li className="">
                                                    <a href={service.getRedirectUrl(`/baby-names/`+this.props.location.pathname.split("/")[2] +`/religion/amp/?ref2=bnalsoreadsection`)} title={`Baby ${
                                                            this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                            return letter.toUpperCase();
                                                        })
                                                        } Names by Religion`}>
                                                        <span className="bullet_icon"></span>
                                                        <span className="R15_61">{`Baby ${
                                                            this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                            return letter.toUpperCase();
                                                        })
                                                        } Names by Religion`} </span>
                                                        <span className="icon right R14_75" data-icon-font="l"></span>
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a href={service.getRedirectUrl(`/baby-names/`+this.props.location.pathname.split("/")[2] +`/origin/amp/?ref2=bnalsoreadsection`)}  title={`Baby ${
                                                            this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                            return letter.toUpperCase();
                                                        })
                                                        } Names by Origin`}>
                                                        <span className="bullet_icon"></span>
                                                        <span className="R15_61">{`Baby ${
                                                            this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                            return letter.toUpperCase();
                                                        })
                                                        } Names by Origin`} </span>
                                                        <span className="icon right R14_75" data-icon-font="l"></span>
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a href={service.getRedirectUrl(`/baby-names/`+this.props.location.pathname.split("/")[2] +`/numerology/amp/?ref2=bnalsoreadsection`)} title={`Baby ${
                                                            this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                            return letter.toUpperCase();
                                                        })
                                                        } Names by Numerology`}>
                                                        <span className="bullet_icon"></span>
                                                        <span className="R15_61">{`Baby ${
                                                            this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                            return letter.toUpperCase();
                                                        })
                                                        } Names by Numerology`} </span>
                                                        <span className="icon right R14_75" data-icon-font="l"></span>
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a href={service.getRedirectUrl(`/baby-names/`+this.props.location.pathname.split("/")[2] +`/rashi/amp/?ref2=bnalsoreadsection`)} title={`Baby ${
                                                            this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                            return letter.toUpperCase();
                                                        })
                                                        } Names by Rashi`}>
                                                        <span className="bullet_icon"></span>
                                                        <span className="R15_61">{`Baby ${
                                                            this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                            return letter.toUpperCase();
                                                        })
                                                        } Names by Rashi`} </span>
                                                        <span className="icon right R14_75" data-icon-font="l"></span>
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a href={service.getRedirectUrl(`/baby-names/`+this.props.location.pathname.split("/")[2] +`/nakshatra/amp/?ref2=bnalsoreadsection`)} title={`Baby ${
                                                            this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                            return letter.toUpperCase();
                                                        })
                                                        } Names by Nakshatra`}>
                                                        <span className="bullet_icon"></span>
                                                        <span className="R15_61">{`Baby ${
                                                            this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                            return letter.toUpperCase();
                                                        })
                                                        } Names by Nakshatra`} </span>
                                                        <span className="icon right R14_75" data-icon-font="l"></span>
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a href={service.getRedirectUrl(`/baby-names/`+this.props.location.pathname.split("/")[2] +`/starting-with/amp/?ref2=bnalsoreadsection`)} title={`Baby ${
                                                            this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                            return letter.toUpperCase();
                                                        })
                                                        } Names Starting With Letters A to Z`}>
                                                        <span className="bullet_icon"></span>
                                                        <span className="R15_61">{`Baby ${
                                                            this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                            return letter.toUpperCase();
                                                        })
                                                        } Names Starting With Letters A to Z`}</span>
                                                        <span className="icon right R14_75" data-icon-font="l"></span>
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a href={service.getRedirectUrl(`/baby-names/`+this.props.location.pathname.split("/")[2] +`/god-goddesses/amp/?ref2=bnalsoreadsection`)} title={`Baby ${
                                                            this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                            return letter.toUpperCase();
                                                        })
                                                        } Names Inspired by ${
                                                            (this.props.location.pathname.split("/")[2] == "boy") ?
                                                            (` Gods`) :
                                                            (` Goddesses`)
                                                            }
                                                        `}
                                                        >
                                                        <span className="bullet_icon"></span>
                                                        <span className="R15_61">{`Baby ${
                                                            this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                            return letter.toUpperCase();
                                                        })
                                                        } Names Inspired by ${
                                                            (this.props.location.pathname.split("/")[2] == "boy") ?
                                                            (` Gods`) :
                                                            (` Goddesses`)
                                                            }
                                                        `}
                                                            </span>
                                                        <span className="icon right R14_75" data-icon-font="l"></span>
                                                    </a>
                                                </li>
                                            </ul>
                                            ) : 
                                            (
                                                (this.props.location.pathname.split("/")[2] == "unisex") ?
                                                (
                                                <ul className="">
                                                    <li className="">
                                                        <a href={service.getRedirectUrl(`/baby-names/`+this.props.location.pathname.split("/")[2] +`/religion/amp/?ref2=bnalsoreadsection`)} title="Unisex Baby Names by Religion">
                                                            <span className="bullet_icon"></span>
                                                            <span className="R15_61">Unisex Baby Names by Religion </span>
                                                            <span className="icon right R14_75" data-icon-font="l"></span>
                                                        </a>
                                                    </li>
                                                    <li className="">
                                                        <a href={service.getRedirectUrl(`/baby-names/`+this.props.location.pathname.split("/")[2] +`/origin/amp/?ref2=bnalsoreadsection`)} title="Unisex Baby Names by Origin">
                                                            <span className="bullet_icon"></span>
                                                            <span className="R15_61">Unisex Baby Names by Origin </span>
                                                            <span className="icon right R14_75" data-icon-font="l"></span>
                                                        </a>
                                                    </li>
                                                    <li className="">
                                                        <a href={service.getRedirectUrl(`/baby-names/`+this.props.location.pathname.split("/")[2] +`/numerology/amp/?ref2=bnalsoreadsection`)} title="Unisex Baby Names by Numerology">
                                                            <span className="bullet_icon"></span>
                                                            <span className="R15_61">Unisex Baby Names by Numerology </span>
                                                            <span className="icon right R14_75" data-icon-font="l"></span>
                                                        </a>
                                                    </li>
                                                    <li className="">
                                                        <a href={service.getRedirectUrl(`/baby-names/`+this.props.location.pathname.split("/")[2] +`/rashi/amp/?ref2=bnalsoreadsection`)} title="Unisex Baby Names by Rashi">
                                                            <span className="bullet_icon"></span>
                                                            <span className="R15_61">Unisex Baby Names by Rashi </span>
                                                            <span className="icon right R14_75" data-icon-font="l"></span>
                                                        </a>
                                                    </li>
                                                    <li className="">
                                                        <a href={service.getRedirectUrl(`/baby-names/`+this.props.location.pathname.split("/")[2] +`/nakshatra/amp/?ref2=bnalsoreadsection`)} title="Unisex Baby Names by Nakshatra">
                                                            <span className="bullet_icon"></span>
                                                            <span className="R15_61">Unisex Baby Names by Nakshatra </span>
                                                            <span className="icon right R14_75" data-icon-font="l"></span>
                                                        </a>
                                                    </li>
                                                    <li className="">
                                                        <a href={service.getRedirectUrl(`/baby-names/`+this.props.location.pathname.split("/")[2] +`/starting-with/amp/?ref2=bnalsoreadsection`)} title="Unisex Baby Names Starting With Letters A to Z">
                                                            <span className="bullet_icon"></span>
                                                            <span className="R15_61">Unisex Baby Names Starting With Letters A to Z </span>
                                                            <span className="icon right R14_75" data-icon-font="l"></span>
                                                        </a>
                                                    </li>
                                                    <li className="">
                                                        <a href={service.getRedirectUrl(`/baby-names/`+this.props.location.pathname.split("/")[2] +`/god-goddesses/amp/?ref2=bnalsoreadsection`)} title="Unisex Baby Names Inspired by Gods and Goddesses">
                                                            <span className="bullet_icon"></span>
                                                            <span className="R15_61">Unisex Baby Names Inspired by Gods and Goddesses </span>
                                                            <span className="icon right R14_75" data-icon-font="l"></span>
                                                        </a>
                                                    </li>
                                                </ul>
                                                ) :
                                                (((this.props.location.pathname.split("/")[2] == 'religion' || this.props.location.pathname.split("/")[2] == 'origin' || this.props.location.pathname.split("/")[2] == 'numerology' || this.props.location.pathname.split("/")[2] == 'rashi' || this.props.location.pathname.split("/")[2] == 'nakshatra' || this.props.location.pathname.split("/")[2] == 'god-goddesses' || this.props.location.pathname.split("/")[2] == 'starting-with') && (this.props.location.pathname.split("/")[2] !== 'finder')) ?
                                                    ((this.props.location.pathname.split("/")[3] == "amp" || this.props.location.pathname.split("/")[3] == "page") ?
                                                        (
                                                            <ul className="">
                                                                <li className="">
                                                                    <a href={service.getRedirectUrl(`/baby-names/boy/`+ this.props.location.pathname.split("/")[2] +`/amp/?ref2=bnalsoreadsection`)} title={`Baby Boy Names by ${this.props.location.pathname.split("/")[2]}`}>
                                                                        <span className="bullet_icon"></span>
                                                                        <span className="R15_61">{`Baby Boy Names by ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                            return letter.toUpperCase();
                                                                        })}`} </span>
                                                                        <span className="icon right R14_75" data-icon-font="l"></span>
                                                                    </a>
                                                                </li>
                                                                <li className="">
                                                                    <a href={service.getRedirectUrl(`/baby-names/girl/`+ this.props.location.pathname.split("/")[2] +`/amp/?ref2=bnalsoreadsection`)} title={`Baby Girl Names by ${this.props.location.pathname.split("/")[2]}`}>
                                                                        <span className="bullet_icon"></span>
                                                                        <span className="R15_61">{`Baby Girl Names by ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}`}</span>
                                                                        <span className="icon right R14_75" data-icon-font="l"></span>
                                                                    </a>
                                                                </li>
                                                                <li className="">
                                                                    <a href={service.getRedirectUrl(`/baby-names/unisex/`+ this.props.location.pathname.split("/")[2] +`/amp/?ref2=bnalsoreadsection`)} title={`Unisex Baby Names by ${this.props.location.pathname.split("/")[2]}`}>
                                                                        <span className="bullet_icon"></span>
                                                                        <span className="R15_61">{`Unisex Baby Names by ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}`} </span>
                                                                        <span className="icon right R14_75" data-icon-font="l"></span>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        ) :
                                                        (   (this.props.location.pathname.split("/")[2] != "starting-with") ?
                                                            (
                                                            <ul className="">
                                                                <li className="">
                                                                <a href={service.getRedirectUrl(`/baby-names/boy/` + this.props.location.pathname.split("/")[2] +`/` + this.props.location.pathname.split("/")[3] + `/amp/?ref2=bnalsoreadsection`)} title={` Baby Boy Names: ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}   ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}`}>
                                                                    <span className="bullet_icon"></span>
                                                                    <span className="R15_61">
                                                                    {`Baby Boy Names: ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })} ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}`} </span>
                                                                    <span className="icon right R14_75" data-icon-font="l"></span>
                                                                </a>
                                                            </li>
                                                            <li className="">
                                                                <a href={service.getRedirectUrl(`/baby-names/girl/` + this.props.location.pathname.split("/")[2] +`/` + this.props.location.pathname.split("/")[3] + `/amp/?ref2=bnalsoreadsection`)} title={`Baby Girl Names: ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })} ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}`}>
                                                                    <span className="bullet_icon"></span>
                                                                    <span className="R15_61">{`Baby Girl Names: ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })} ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}`}</span>
                                                                    <span className="icon right R14_75" data-icon-font="l"></span>
                                                                </a>
                                                            </li>
                                                            <li className="">
                                                                <a href={service.getRedirectUrl(`/baby-names/unisex/` + this.props.location.pathname.split("/")[2] +`/` + this.props.location.pathname.split("/")[3] + `/amp/?ref2=bnalsoreadsection`)} title={`Unisex Baby Names: ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}   ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })} `}>
                                                                    <span className="bullet_icon"></span>
                                                                    <span className="R15_61">{`Unisex Baby Names: ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}   ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}`} </span>
                                                                    <span className="icon right R14_75" data-icon-font="l"></span>
                                                                </a>
                                                            </li>
                                                            <li className="">
                                                                <a href={service.getRedirectUrl(`/baby-names/boy/` + this.props.location.pathname.split("/")[2] +`/` + this.props.location.pathname.split("/")[3] + `/starting-with/a/amp/?ref2=bnalsoreadsection`)} title={` Baby Boy Names Starting with A : ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}  ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}`}>
                                                                    <span className="bullet_icon"></span>
                                                                    <span className="R15_61">
                                                                    {`Baby Boy Names Starting with A : ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}  ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}`}
                                                                    </span>
                                                                    <span className="icon right R14_75" data-icon-font="l"></span>
                                                                </a>
                                                            </li>
                                                            <li className="">
                                                                <a href={service.getRedirectUrl(`/baby-names/boy/` + this.props.location.pathname.split("/")[2] +`/` + this.props.location.pathname.split("/")[3] + `/starting-with/s/amp/?ref2=bnalsoreadsection`)} title={` Baby Boy Names Starting with S : ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}   ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}`}>
                                                                    <span className="bullet_icon"></span>
                                                                    <span className="R15_61">
                                                                    {`Baby Boy Names Starting with S : ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}  ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}`}
                                                                    </span>
                                                                    <span className="icon right R14_75" data-icon-font="l"></span>
                                                                </a>
                                                            </li>
                                                            <li className="">
                                                                <a href={service.getRedirectUrl(`/baby-names/girl/` + this.props.location.pathname.split("/")[2] +`/` + this.props.location.pathname.split("/")[3] + `/starting-with/a/amp/?ref2=bnalsoreadsection`)} title={`Baby Girl Names Starting with A : ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}   ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}`}>
                                                                    <span className="bullet_icon"></span>
                                                                    <span className="R15_61">{`Baby Girl Names Starting with A : ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}   ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}`}</span>
                                                                    <span className="icon right R14_75" data-icon-font="l"></span>
                                                                </a>
                                                            </li>
                                                            <li className="">
                                                                <a href={service.getRedirectUrl(`/baby-names/girl/` + this.props.location.pathname.split("/")[2] +`/` + this.props.location.pathname.split("/")[3] + `/starting-with/s/amp/?ref2=bnalsoreadsection`)} title={`Baby Girl Names Starting with S : ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}   ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}`}>
                                                                    <span className="bullet_icon"></span>
                                                                    <span className="R15_61">{`Baby Girl Names Starting with S : ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}  ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                        return letter.toUpperCase();
                                                                    })}`}</span>
                                                                    <span className="icon right R14_75" data-icon-font="l"></span>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                            ) :
                                                            (
                                                                <ul className="">
                                                                    <li className="">
                                                                    <a href={service.getRedirectUrl(`/baby-names/boy/` + this.props.location.pathname.split("/")[2] +`/` + this.props.location.pathname.split("/")[3] + `/amp/?ref2=bnalsoreadsection`)} title={` Baby Boy Names: ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                            return letter.toUpperCase();
                                                                        })}   ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                            return letter.toUpperCase();
                                                                        })}`}>
                                                                        <span className="bullet_icon"></span>
                                                                        <span className="R15_61">
                                                                        {`Baby Boy Names: ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                            return letter.toUpperCase();
                                                                        })} ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                            return letter.toUpperCase();
                                                                        })}`} </span>
                                                                        <span className="icon right R14_75" data-icon-font="l"></span>
                                                                    </a>
                                                                </li>
                                                                <li className="">
                                                                    <a href={service.getRedirectUrl(`/baby-names/girl/` + this.props.location.pathname.split("/")[2] +`/` + this.props.location.pathname.split("/")[3] + `/amp/?ref2=bnalsoreadsection`)} title={`Baby Girl Names: ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                            return letter.toUpperCase();
                                                                        })}
                                                                            
                                                                        ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                            return letter.toUpperCase();
                                                                        })}`}>
                                                                        <span className="bullet_icon"></span>
                                                                        <span className="R15_61">{`Baby Girl Names: ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                            return letter.toUpperCase();
                                                                        })} ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                            return letter.toUpperCase();
                                                                        })}`}</span>
                                                                        <span className="icon right R14_75" data-icon-font="l"></span>
                                                                    </a>
                                                                </li>
                                                                <li className="">
                                                                    <a href={service.getRedirectUrl(`/baby-names/unisex/` + this.props.location.pathname.split("/")[2] +`/` + this.props.location.pathname.split("/")[3] + `/amp/?ref2=bnalsoreadsection`)} title={`Unisex Baby Names: ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                            return letter.toUpperCase();
                                                                        })}   ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                            return letter.toUpperCase();
                                                                        })} `}>
                                                                        <span className="bullet_icon"></span>
                                                                        <span className="R15_61">{`Unisex Baby Names: ${this.props.location.pathname.split("/")[2].replace(/\b[a-z]/g, function(letter) {
                                                                            return letter.toUpperCase();
                                                                        })} ${this.props.location.pathname.split("/")[3].replace(/\b[a-z]/g, function(letter) {
                                                                            return letter.toUpperCase();
                                                                        })}`} </span>
                                                                        <span className="icon right R14_75" data-icon-font="l"></span>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                            )
                                                        )
                                                    )
                                                    :
                                                    (   <ul className="alsoReadData">
                                                        {(jsonAlsoData != undefined) ?
                                                            (jsonAlsoData.map((value, index) =>  (
                                                                <li className="" key={index}>
                                                                    <a href={`${value.listLink.replace('//parenting', '//stageparenting')}amp/?ref2=bnalsoreadsection`}>
                                                                        <span className="bullet_icon"></span>
                                                                        <span className="R15_61">{value.listName}</span>
                                                                        <span className="icon right R14_75" data-icon-font="l"></span>
                                                                    </a>
                                                                </li>
                                                            ))) 
                                                            : 
                                                            ''
                                                        }
                                                        </ul>
                                                    )
                                                )
                                            )
                                    }
                                </div>) :
                                ''
                                //end also read
                            }
                            
                            {
                                (this.props.location.pathname.includes("page") || ((this.props.location.pathname.split("/")[2] == "religion" || this.props.location.pathname.split("/")[2] == "origin" || this.props.location.pathname.split("/")[2] == "boy" || this.props.location.pathname.split("/")[2] == "girl" || this.props.location.pathname.split("/")[2] == "unisex") && (this.props.location.pathname.split("/")[3] == "")) || (this.props.location.pathname.split("/")[4] == "starting-with" || this.props.location.pathname.split("/")[5] == "starting-with")) ?
                                '' :
                                (
                                    <div className="list_description">
                                        <div className="">
                                            <div className="R14_75 baby_name_finder_text">
                                                {`We hope you have found the perfect name for your little bundle of joy from our compilation of unique and trending ${_heading}`}
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            <div className="article_block search_name">
                                
                                <div className="articles_heading">
                                    <h2 className="M18_42">Articles on Baby Names</h2>
                                </div>
                                
                                <div className="article_slider_cont" id="article_slider_cont">
                                    <amp-carousel height="138" layout="fixed-height" type="carousel">
                                        {jsonArticle && jsonArticle.map((value, index) => 
                                            <div key={index} className="experts-cnt" id="dev_art_lst">
                                                <a href={`${value.articleURL}?ref2=bncarouselslider/amp/`} target="_blank">
                                                    <div className="expert-image">
                                                        <amp-img layout="responsive" width="197" height="98" src={value.articleImage}></amp-img>
                                                    </div>
                                                    <div className="M14_42">{value.articleTitle}</div>
                                                </a>
                                            </div>
                                        )}
                                    </amp-carousel>
                                </div>
                            </div>
                            <div className="collectionListCont">
                            {   (global.ftk) ?
                                    <a href={service.getRedirectUrl("/baby-names/favorite-baby-names/amp/")}>
                                        <span className="icon collectionIcon" data-icon-font="&#xe044;"></span>
                                    </a>
                                    :
                                    <div tabIndex="0" role="button" on="tap:loginToggle.restart">
                                        <a href={`${global.loginUrl}?URL=${global.currentURL}`} tabIndex="0" role="button">
                                            <span className="icon collectionIcon" data-icon-font="&#xe044;"></span>
                                        </a>
                                        <div className="alertMsgoverlay">
                                            <span className="alertmsg">Please Login</span>
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className="sort-list-popup" id="sort-list-popup" onClick={(e) => this.hideSort()} hidden>
                                <div className="sort-menu">
                                    <span className="right icon" data-icon-font="C" role="button" tabIndex="0" on="tap:sort-list-popup.hide"></span>
                                    <ul>
                                    <li className="most-popular dev_sort R14_42" id="dev_pop_mst" onClick={(e) => actions.sortby(e, this)}>
                                            Most Popular
                                        </li>
                                        <li className="not-in-my-collection R14_42 dev_sort" id="dev_nt_m_coll" onClick={(e) => actions.sortby(e, this)}>
                                            Not in my collection
                                        </li>
                                        <li className="not-in-top-10 R14_42 dev_sort" id="dev_nt_10" onClick={(e) => actions.sortby(e, this)}>
                                            Not in top 10
                                        </li>
                                        <li className="not-in-top-100 R14_42 dev_sort" id="dev_nt_100" onClick={(e) => actions.sortby(e, this)}>
                                            Not in top 100
                                        </li>
                                        <li className="not-in-top-1000 R14_42 dev_sort" id="dev_nt_1000" onClick={(e) => actions.sortby(e, this)}>
                                            Not in top 1000
                                        </li>
                                        <li className="top-10 R14_42 dev_sort" id="dev_tp_10" onClick={(e) => actions.sortby(e, this)}>
                                            Top 10
                                        </li>
                                        <li className="top-100 R14_42 dev_sort" id="dev_tp_100" onClick={(e) => actions.sortby(e, this)}>
                                            Top 100
                                        </li>
                                        <li className="top-1000 R14_42 dev_sort" id="dev_tp_1000" onClick={(e) => actions.sortby(e, this)}>
                                            Top 1000
                                        </li>
                                        <li className="sort-asce R14_42 dev_sort" id="dev_srt_alp" onClick={(e) => actions.sortby(e, this)}>
                                            Sort A to Z
                                        </li>
                                        <li className="sort-desc R14_42 dev_sort" id="dev_dsrt_alp" onClick={(e) => actions.sortby(e, this)}>
                                            Sort Z to A
                                        </li>
                                    </ul>
                                </div>
                            </div> 
                            <div className="name-added">
                                <div className="nm-add">
                                    <span>
                                    </span>
                                </div>
                            </div>
                        <FilterCategory eleRef={this.state.filterData} eleThis={this} />

                        {/* {this.CollectionListPopup (this.state.collectionListData, recordID,babynametoadd, this)} */}
                        <CollectionListPopupAmp eleRef={this.state.collectionListData} eleRecord={recordID} eleName={babynametoadd} />

                        </div>
                    </div>
                </div>
                {/* <div id="toastMsg">
                    <span className="R14_white">Please select atleast one Filter</span>
                </div>  */}
            </main>
        )
    }
}

export default BabynamesListingAmp



// WEBPACK FOOTER //
// src/shared/baby-names-amp/BabynamesListingAmp.js